const lukkeyLocalizedCoreTranslations = {
  zh: {
    "lukkey.hero.subtitle": "资产在你手中，掌控由你",
    "lukkey.hero.reserveSubtitle":
      "支付 1 美元预订，即可锁定早鸟价格、优先资格和免费 NFC 备份卡。",
    "lukkey.hero.priceHighlightPrefix": "Kickstarter 众筹价",
    "lukkey.hero.priceHighlightMiddle": "现在支付 1 美元即可锁定",
    "lukkey.hero.priceHighlightSuffix": "发售价。",
    "lukkey.hero.priceHighlightSavings": "立省 20 美元。",
    "lukkey.hero.heroCtaLabel": "支付 1 美元预订",
    "lukkey.hero.heroCtaNote": "全额可退。无需作出购买承诺。",
    "lukkey.hero.buy": "1 美元预定 Lukkey",
    "lukkey.hero.buyWithPrice": "以 {{price}} 预定 Lukkey",
    "lukkey.hero.swissBadgeLabel": "瑞士品牌",
    "lukkey.hero.seoEyebrow": "面向安全自托管的瑞士硬件钱包",
    "lukkey.hero.awards.ifDesignAlt": "2025 iF 设计奖徽章",
    "lukkey.hero.awards.redDotAlt": "2025 红点奖徽章",
    "lukkey.cart.title": "查看购物车",
    "lukkey.cart.close": "关闭购物车",
    "lukkey.cart.empty": "购物车为空。",
    "lukkey.cart.delete": "删除",
    "lukkey.cart.reserveDetailsTitle": "你的 $1 预订权益",
    "lukkey.cart.priceCalloutEyebrow": "众筹价格",
    "lukkey.cart.priceCalloutBody":
      "Kickstarter 众筹价 299 美元。现在支付 1 美元预订，即可锁定 279 美元发售价格。",
    "lukkey.cart.reserveDetails.bullet1": "早鸟价立减 20 美元",
    "lukkey.cart.reserveDetails.bullet2": "第一时间收到上线邮件，并抢先进入众筹页面",
    "lukkey.cart.reserveDetails.bullet3": "优先发货",
    "lukkey.cart.reserveDetails.bullet4": "VIP 社群资格",
    "lukkey.cart.reserveDetails.bullet5": "限量版 NFC 备份卡和专属 IP 礼品",
    "lukkey.cart.moreColors": "更多颜色（即将推出）",
    "lukkey.cart.comingSoon": "即将推出",
    "lukkey.cart.total": "合计",
    "lukkey.cart.checkout": "结账",
    "lukkey.seo.title": "LUKKEY 硬件钱包 | 支持指纹访问的离线加密冷钱包",
    "lukkey.seo.description": "LUKKEY 是面向安全自托管的瑞士硬件钱包，提供离线私钥保护、EAL6+ 安全芯片、指纹访问、NFC 备份，以及多套独立钱包支持。",
    "lukkey.seoIntent.eyebrow": "硬件钱包选购指南",
    "lukkey.seoIntent.title": "为什么用户会搜索像 LUKKEY 这样的冷钱包",
    "lukkey.seoIntent.intro": "一款硬件钱包不该只是看起来安全，还应真正让私钥保持离线、让恢复流程更可控，并为长期持币用户提供更清晰的自托管路径。",
    "lukkey.seoIntent.cards.offline.title": "离线私钥存储",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY 作为硬件冷钱包，核心目标是让私钥始终留在离线环境中，而不是暴露在浏览器、交易所或始终联网的软件钱包里。",
    "lukkey.seoIntent.cards.compare.title": "冷钱包与热钱包的区别",
    "lukkey.seoIntent.cards.compare.body": "对于长期持有者和重视安全的加密用户，冷钱包可以减少远程攻击面，相比只把资产放在交易所或软件钱包中，拥有更直接的控制权。",
    "lukkey.seoIntent.cards.recovery.title": "指纹访问与 NFC 备份",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY 将硬件级安全与日常可用性结合起来，用指纹访问提升使用效率，并通过 NFC 备份流程让自托管恢复更安全、更顺手。",
    "lukkey.seoIntent.cards.fit.title": "为安全自托管而生",
    "lukkey.seoIntent.cards.fit.body": "如果你正在寻找适合 Bitcoin、Ethereum、USDT 以及多账户管理的硬件钱包，LUKKEY 的设计重点就是隐私、隔离和长期控制权。",
    "lukkey.highlights.eyebrow": "核心亮点",
    "lukkey.highlights.title": "了解 Lukkey 核心亮点。",
    "lukkey.highlights.description":
      "先看懂 LUKKEY 最关键的 5 个卖点，再继续往下了解对应章节的完整细节。",
    "lukkey.highlights.cards.chip.title": "EAL6+ 安全芯片",
    "lukkey.highlights.cards.chip.description":
      "以硬件级信任根守住关键密钥材料，让核心数据始终停留在认证级安全元件内部。",
    "lukkey.highlights.cards.chip.sectionLabel": "芯片安全",
    "lukkey.highlights.cards.multiAccount.title": "3 套独立助记词",
    "lukkey.highlights.cards.multiAccount.description":
      "把长期持仓、日常资金与不同身份策略分开管理，一台设备内完成清晰隔离。",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "多账户",
    "lukkey.highlights.cards.safeMode.title": "安全模式",
    "lukkey.highlights.cards.safeMode.description":
      "通过伪装界面与隐藏账户机制，在出行、公开场景或高压情境下减少资产暴露。",
    "lukkey.highlights.cards.safeMode.sectionLabel": "安全层",
    "lukkey.highlights.cards.backup.title": "NFC 备份卡",
    "lukkey.highlights.cards.backup.description":
      "轻触即可完成助记词备份或恢复，为离线保管和设备延续性提供更直接的路径。",
    "lukkey.highlights.cards.backup.sectionLabel": "备份",
    "lukkey.highlights.cards.trust.title": "开放且可验证的安全",
    "lukkey.highlights.cards.trust.description":
      "冷钱包最重要的不只是声称安全，而是能被独立审查与验证的安全架构。",
    "lukkey.highlights.cards.trust.sectionLabel": "信任",
    "lukkey.highlights.carousel.previous": "上一组亮点",
    "lukkey.highlights.carousel.next": "下一组亮点",
    "lukkey.physical.title": "安全，生于硅芯。",
    "lukkey.physical.subtitle":
      "由多个安全元件构建的硬件安全架构，以 EAL6+ 级信任根为锚点，并通过防篡改电路与结构设计进一步加固。",
    "lukkey.design.title": "设计不是装饰，而是可信度",
    "lukkey.design.description":
      "工业设计达到 iF 与红点奖级别工艺水准，强调倒角边缘与细腻玻璃反光。",
    "lukkey.reliability.title": "IP68 防水\nIP6X 防尘",
    "lukkey.reliability.description":
      "支持 IP68 级防水与 IP6X 级防尘，在严苛环境中依然有效阻隔进水与粉尘侵入。",
    "lukkey.reliability.canvasLine1": "IP68 防水",
    "lukkey.reliability.canvasLine2": "IP6X 防尘",
    "lukkey.system.title": "安全模式",
    "lukkey.system.description":
      "在敏感场景下提供更隐蔽的保护层。\n\nSafenotes 会把钱包界面伪装成备忘录页面，\n同时仅保留当前账户可见。\n单账户删除等敏感操作也会被限制。",
    "lukkey.system.multiAccountTitle": "支持 3 套独立助记词",
    "lukkey.system.multiAccountDescription":
      "最多创建三套完全独立的钱包，每套都由自己的助记词保护。你可以分离资产、策略或身份，同时始终保持对数字资产的完全掌控。",
    "lukkey.daily.title": "指纹解锁",
    "lukkey.daily.description":
      "通过指纹认证即时解锁你的钱包。\n\n快速、顺滑，并且所有验证都直接在设备端完成。",
    "lukkey.capability.title": "NFT 支持",
    "lukkey.capability.description":
      "深色空间中的资产展示舱，以玻璃质感卡片和低饱和视觉突出所有权与掌控感。",
    "lukkey.backup.title": "NFC 备份卡",
    "lukkey.backup.description":
      "一张内置 EAL6+ 安全芯片的 NFC 备份卡。\n只需轻触设备，即可安全备份或导入助记词。",
    "lukkey.trust.title": "开放且可验证的安全",
    "lukkey.trust.description":
      "基于 EAL6+ 安全芯片与开源架构，\nLUKKEY 让硬件与软件安全都能被独立验证。\n\n密钥生成、存储与签名始终在设备内部完成保护，\n而开源代码则让社区可以透明审查其安全性。\n\n可验证的安全，始终属于你的控制权。",
    "lukkey.video.title": "为保护而生，为长期而设计。",
    "lukkey.video.description":
      "源自瑞士工艺，偏执追求安全。LUKKEY 为追求绝对掌控的人而生。",
    "lukkey.values.privacy.title": "隐私",
    "lukkey.values.privacy.description":
      "私钥永不离开设备。离线签名让敏感操作始终保持完全离线。",
    "lukkey.values.inclusive.title": "包容式设计",
    "lukkey.values.inclusive.description":
      "以人为中心的设计，对新手清晰易懂，对进阶用户同样高效顺手。",
    "lukkey.values.secure.title": "安全",
    "lukkey.values.secure.description":
      "硬件级防护叠加多层安全机制，抵御篡改、提取与伪装风险。",
    "lukkey.values.environment.title": "可持续",
    "lukkey.values.environment.description":
      "为长期使用而打造，采用耐用材料、可维护结构，并减少更换带来的浪费。",
    "lukkey.contact.title": "保持联系",
    "lukkey.contact.announcements": "最新公告可在我们的博客中查看。",
    "lukkey.contact.pressLabel": "媒体联系：",
  },
  "zh-TW": {
    "lukkey.hero.subtitle": "資產在你手中，掌控由你",
    "lukkey.hero.reserveSubtitle":
      "支付 1 美元預訂，即可鎖定早鳥價格、優先資格與免費 NFC 備份卡。",
    "lukkey.hero.priceHighlightPrefix": "Kickstarter 眾籌價",
    "lukkey.hero.priceHighlightMiddle": "現在支付 1 美元即可鎖定",
    "lukkey.hero.priceHighlightSuffix": "發售價。",
    "lukkey.hero.priceHighlightSavings": "立省 20 美元。",
    "lukkey.hero.heroCtaLabel": "支付 1 美元預訂",
    "lukkey.hero.heroCtaNote": "可全額退款，無需作出購買承諾。",
    "lukkey.hero.buy": "1 美元預訂 Lukkey",
    "lukkey.hero.buyWithPrice": "以 {{price}} 預訂 Lukkey",
    "lukkey.hero.swissBadgeLabel": "瑞士品牌",
    "lukkey.hero.seoEyebrow": "面向安全自我託管的瑞士硬體錢包",
    "lukkey.hero.awards.ifDesignAlt": "2025 iF 設計獎徽章",
    "lukkey.hero.awards.redDotAlt": "2025 紅點獎徽章",
    "lukkey.cart.title": "查看購物車",
    "lukkey.cart.close": "關閉購物車",
    "lukkey.cart.empty": "購物車為空。",
    "lukkey.cart.delete": "刪除",
    "lukkey.cart.reserveDetailsTitle": "你的 $1 預訂權益",
    "lukkey.cart.priceCalloutEyebrow": "眾籌價格",
    "lukkey.cart.priceCalloutBody":
      "Kickstarter 眾籌價 299 美元。現在支付 1 美元預訂，即可鎖定 279 美元發售價格。",
    "lukkey.cart.reserveDetails.bullet1": "早鳥價現折 20 美元",
    "lukkey.cart.reserveDetails.bullet2": "第一時間收到上線通知郵件，並搶先進入眾籌頁面",
    "lukkey.cart.reserveDetails.bullet3": "優先出貨",
    "lukkey.cart.reserveDetails.bullet4": "VIP 社群資格",
    "lukkey.cart.reserveDetails.bullet5": "限量版 NFC 備份卡和專屬 IP 禮品",
    "lukkey.cart.moreColors": "更多顏色（即將推出）",
    "lukkey.cart.comingSoon": "即將推出",
    "lukkey.cart.total": "合計",
    "lukkey.cart.checkout": "結帳",
    "lukkey.seo.title": "LUKKEY 硬體錢包 | 支援指紋存取的離線加密冷錢包",
    "lukkey.seo.description": "LUKKEY 是面向安全自我託管的瑞士硬體錢包，提供離線私鑰保護、EAL6+ 安全晶片、指紋存取、NFC 備份，以及多組獨立錢包支援。",
    "lukkey.seoIntent.eyebrow": "硬體錢包選購指南",
    "lukkey.seoIntent.title": "為什麼使用者會搜尋像 LUKKEY 這樣的冷錢包",
    "lukkey.seoIntent.intro": "一款硬體錢包不該只是看起來安全，還應真正讓私鑰保持離線、讓恢復流程更可控，並為長期持幣者提供更清晰的自我託管路徑。",
    "lukkey.seoIntent.cards.offline.title": "離線私鑰儲存",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY 作為硬體冷錢包，核心目標是讓私鑰始終停留在離線環境中，而不是暴露在瀏覽器、交易所或持續連網的軟體錢包裡。",
    "lukkey.seoIntent.cards.compare.title": "冷錢包與熱錢包的差異",
    "lukkey.seoIntent.cards.compare.body": "對長期持有者和重視安全的加密使用者來說，冷錢包能降低遠端攻擊面，相比僅把資產放在交易所或軟體錢包裡，擁有更直接的控制權。",
    "lukkey.seoIntent.cards.recovery.title": "指紋存取與 NFC 備份",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY 將硬體級安全與日常可用性結合，用指紋存取提升效率，並以 NFC 備份流程讓自我託管的恢復更安全、更順手。",
    "lukkey.seoIntent.cards.fit.title": "為安全自我託管而生",
    "lukkey.seoIntent.cards.fit.body": "如果你正在尋找適合 Bitcoin、Ethereum、USDT 以及多帳戶管理的硬體錢包，LUKKEY 的設計重點就是隱私、隔離與長期控制權。",
    "lukkey.highlights.eyebrow": "核心亮點",
    "lukkey.highlights.title": "掌握 Lukkey 核心亮點。",
    "lukkey.highlights.description":
      "先快速掌握 LUKKEY 最關鍵的 5 個賣點，再往下查看對應章節的完整細節。",
    "lukkey.highlights.cards.chip.title": "EAL6+ 安全晶片",
    "lukkey.highlights.cards.chip.description":
      "以硬體級信任根保護關鍵金鑰資料，讓核心資訊始終停留在認證級安全元件內部。",
    "lukkey.highlights.cards.chip.sectionLabel": "晶片安全",
    "lukkey.highlights.cards.multiAccount.title": "3 組獨立助記詞",
    "lukkey.highlights.cards.multiAccount.description":
      "把長期持倉、日常資金與不同身份策略分開管理，在一台裝置內清楚隔離。",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "多帳戶",
    "lukkey.highlights.cards.safeMode.title": "安全模式",
    "lukkey.highlights.cards.safeMode.description":
      "透過偽裝介面與隱藏帳戶機制，在出行、公開場合或高壓情境下減少資產暴露。",
    "lukkey.highlights.cards.safeMode.sectionLabel": "安全層",
    "lukkey.highlights.cards.backup.title": "NFC 備份卡",
    "lukkey.highlights.cards.backup.description":
      "輕觸即可完成助記詞備份或還原，為離線保管與裝置延續性提供更直接的方式。",
    "lukkey.highlights.cards.backup.sectionLabel": "備份",
    "lukkey.highlights.cards.trust.title": "開放且可驗證的安全",
    "lukkey.highlights.cards.trust.description":
      "冷錢包最重要的不只是宣稱安全，而是能被獨立審查與驗證的安全架構。",
    "lukkey.highlights.cards.trust.sectionLabel": "信任",
    "lukkey.highlights.carousel.previous": "上一組亮點",
    "lukkey.highlights.carousel.next": "下一組亮點",
    "lukkey.physical.title": "安全，生於矽芯。",
    "lukkey.physical.subtitle":
      "由多個安全元件構成的硬體安全架構，以 EAL6+ 信任根為核心，並透過防篡改電路與結構設計進一步強化。",
    "lukkey.design.title": "設計不是裝飾，而是可信度",
    "lukkey.design.description":
      "工業設計達到 iF 與紅點獎等級工藝，強調倒角邊緣與細膩玻璃反光。",
    "lukkey.reliability.title": "IP68 防水\nIP6X 防塵",
    "lukkey.reliability.description":
      "支援 IP68 等級防水與 IP6X 等級防塵，在嚴苛環境中依然有效阻隔進水與粉塵侵入。",
    "lukkey.reliability.canvasLine1": "IP68 防水",
    "lukkey.reliability.canvasLine2": "IP6X 防塵",
    "lukkey.system.title": "安全模式",
    "lukkey.system.description":
      "在敏感情境下提供更隱蔽的保護層。\n\nSafenotes 會把錢包介面偽裝成備忘錄頁面，\n同時僅保留目前帳戶可見。\n像單一帳戶刪除等敏感操作也會受到限制。",
    "lukkey.system.multiAccountTitle": "支援 3 組獨立助記詞",
    "lukkey.system.multiAccountDescription":
      "最多建立三套完全獨立的錢包，每套都由自己的助記詞保護。你可以區分資產、策略或身份，同時始終保有對數位資產的完全掌控。",
    "lukkey.daily.title": "指紋解鎖",
    "lukkey.daily.description":
      "透過指紋驗證立即解鎖你的錢包。\n\n快速、順暢，並且所有驗證都直接在裝置端完成。",
    "lukkey.capability.title": "NFT 支援",
    "lukkey.capability.description":
      "深色空間中的資產展示艙，以玻璃質感卡片與低飽和視覺凸顯所有權與掌控感。",
    "lukkey.backup.title": "NFC 備份卡",
    "lukkey.backup.description":
      "一張內建 EAL6+ 安全晶片的 NFC 備份卡。\n只需輕觸裝置，即可安全備份或匯入助記詞。",
    "lukkey.trust.title": "開放且可驗證的安全",
    "lukkey.trust.description":
      "建立於 EAL6+ 安全晶片與開源架構之上，\nLUKKEY 讓硬體與軟體安全都能被獨立驗證。\n\n金鑰生成、儲存與簽名始終在裝置內部受到保護，\n而開源程式碼則讓社群能透明審查其安全性。\n\n可驗證的安全，始終屬於你的控制權。",
    "lukkey.video.title": "為保護而生，為長久而設計。",
    "lukkey.video.description":
      "源自瑞士工藝，偏執追求安全。LUKKEY 為追求絕對掌控的人而生。",
    "lukkey.values.privacy.title": "隱私",
    "lukkey.values.privacy.description":
      "私鑰永不離開裝置。離線簽名讓敏感操作始終維持完全離線。",
    "lukkey.values.inclusive.title": "包容式設計",
    "lukkey.values.inclusive.description":
      "以人為中心的設計，對新手清楚易懂，對進階使用者同樣高效順手。",
    "lukkey.values.secure.title": "安全",
    "lukkey.values.secure.description":
      "硬體級防護疊加多層安全機制，抵禦篡改、提取與偽裝風險。",
    "lukkey.values.environment.title": "永續",
    "lukkey.values.environment.description":
      "為長期使用而打造，採用耐用材料、可維護結構，並減少更換帶來的浪費。",
    "lukkey.contact.title": "保持聯繫",
    "lukkey.contact.announcements": "最新公告可在我們的部落格中查看。",
    "lukkey.contact.pressLabel": "媒體聯絡：",
  },
  es: {
    "lukkey.hero.subtitle": "Tus activos, tu control.",
    "lukkey.hero.reserveSubtitle":
      "Reserva con 1 $. Obtén precio Early Bird, acceso prioritario y una tarjeta NFC de respaldo gratis.",
    "lukkey.hero.heroCtaLabel": "Reserva por 1 $",
    "lukkey.hero.heroCtaNote": "Totalmente reembolsable. Sin compromiso de compra.",
    "lukkey.hero.buy": "Reserva Lukkey con 1 $",
    "lukkey.hero.buyWithPrice": "Reserva Lukkey por {{price}}",
    "lukkey.hero.swissBadgeLabel": "Marca suiza",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet cripto offline con acceso por huella",
    "lukkey.seo.description": "LUKKEY es un hardware wallet suizo para una autocustodia segura, con protección offline de claves privadas, chip seguro EAL6+, acceso por huella, respaldo NFC y soporte para múltiples billeteras independientes.",
    "lukkey.seoIntent.eyebrow": "Guía de hardware wallets",
    "lukkey.seoIntent.title": "Por qué la gente busca una cold wallet como LUKKEY",
    "lukkey.seoIntent.intro": "Un hardware wallet debe hacer más que parecer seguro. Debe mantener las claves privadas offline, hacer que la recuperación sea práctica y ofrecer a los holders de largo plazo una ruta de autocustodia más clara.",
    "lukkey.seoIntent.cards.offline.title": "Almacenamiento offline de claves privadas",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY está diseñado como un hardware wallet que mantiene las claves privadas offline en lugar de dejarlas expuestas en un navegador, exchange o app siempre conectada.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Para holders de largo plazo y usuarios serios de cripto, una cold wallet reduce la superficie de ataque remota y ofrece un control más directo que dejar los activos solo en exchanges o wallets de software.",
    "lukkey.seoIntent.cards.recovery.title": "Acceso por huella y respaldo NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY combina seguridad basada en hardware con herramientas de recuperación prácticas, incluido acceso por huella para el uso diario y flujos de respaldo NFC pensados para una autocustodia más segura.",
    "lukkey.seoIntent.cards.fit.title": "Diseñado para una autocustodia segura",
    "lukkey.seoIntent.cards.fit.body": "Si buscas un hardware wallet para Bitcoin, Ethereum, USDT y gestión de múltiples cuentas cripto, LUKKEY está diseñado en torno a la privacidad, la separación y el control a largo plazo.",
    "lukkey.highlights.title": "Descubre los puntos clave de Lukkey.",
    "lukkey.physical.title": "Seguridad, integrada en el silicio.",
    "lukkey.physical.subtitle":
      "Una arquitectura de seguridad de hardware construida sobre múltiples elementos seguros, anclada en una raíz de confianza EAL6+ y reforzada con diseño estructural y de circuitos resistente a manipulaciones.",
    "lukkey.design.title": "El diseño no es decoración, es credibilidad",
    "lukkey.design.description":
      "Diseño industrial con un nivel de artesanía digno de iF y Red Dot, destacando bordes biselados y sutiles reflejos en el cristal.",
    "lukkey.reliability.title": "IP68 resistente al agua\nIP6X resistente al polvo",
    "lukkey.reliability.description":
      "Protección impermeable IP68 y resistencia al polvo IP6X, diseñada para bloquear el agua y las partículas finas en entornos exigentes.",
    "lukkey.reliability.canvasLine1": "IP68 resistente al agua",
    "lukkey.reliability.canvasLine2": "IP6X resistente al polvo",
    "lukkey.system.title": "Modo seguro",
    "lukkey.system.description":
      "Una capa de protección discreta para situaciones sensibles.\n\nSafenotes disfraza la interfaz de la billetera como una página de notas,\nmientras solo la cuenta activa permanece visible.\nLas operaciones sensibles, como la eliminación de una sola cuenta, están restringidas.",
    "lukkey.system.multiAccountTitle":
      "Compatible con 3 frases de recuperación independientes",
    "lukkey.system.multiAccountDescription":
      "Crea hasta tres billeteras completamente independientes, cada una protegida por su propia frase de recuperación. Separa activos, estrategias o identidades manteniendo el control total de tus activos digitales.",
    "lukkey.daily.title": "Desbloqueo por huella",
    "lukkey.daily.description":
      "Desbloquea tu billetera al instante con autenticación por huella digital.\n\nRápido, fluido y verificado directamente en el dispositivo.",
    "lukkey.capability.title": "Compatibilidad con NFT",
    "lukkey.capability.description":
      "Una vitrina de activos en un espacio oscuro con tarjetas de aspecto vítreo y baja saturación para enfatizar propiedad y control.",
    "lukkey.backup.title": "Tarjeta NFC de respaldo",
    "lukkey.backup.description":
      "Una tarjeta NFC de respaldo con un elemento seguro EAL6+.\nSolo toca el dispositivo para respaldar o importar frases de recuperación de forma segura.",
    "lukkey.trust.title": "Seguridad abierta y verificable",
    "lukkey.trust.description":
      "Construido sobre un elemento seguro EAL6+ y una arquitectura de código abierto,\nLUKKEY permite verificar de forma independiente tanto la seguridad del hardware como la del software.\n\nLa generación, el almacenamiento y la firma de claves permanecen protegidos dentro del dispositivo,\nmientras el código abierto permite una revisión de seguridad transparente por parte de la comunidad.\n\nSeguridad que puedes verificar. Control que sigue siendo tuyo.",
    "lukkey.video.title": "Hecho para proteger. Diseñado para durar.",
    "lukkey.video.description":
      "Fabricado con precisión suiza y obsesionado con la seguridad, LUKKEY es la billetera fría para quienes exigen control total.",
    "lukkey.values.privacy.title": "Privacidad",
    "lukkey.values.privacy.description":
      "Tus claves nunca salen del dispositivo. La firma air-gapped mantiene las operaciones sensibles completamente offline.",
    "lukkey.values.inclusive.title": "Diseño inclusivo",
    "lukkey.values.inclusive.description":
      "Diseño centrado en las personas, claro para principiantes y eficiente para expertos.",
    "lukkey.values.secure.title": "Seguro",
    "lukkey.values.secure.description":
      "Protección respaldada por hardware con múltiples capas contra manipulación, extracción y suplantación.",
    "lukkey.values.environment.title": "Sostenibilidad",
    "lukkey.values.environment.description":
      "Diseñado para un uso duradero con materiales resistentes, estructura reparable y menos residuos por reemplazo.",
    "lukkey.contact.title": "Mantente en contacto",
    "lukkey.contact.announcements": "Los anuncios se pueden encontrar en nuestro blog.",
    "lukkey.contact.pressLabel": "Contacto de prensa:",
  },
  fr: {
    "lukkey.hero.subtitle": "Vos actifs. Votre contrôle.",
    "lukkey.hero.reserveSubtitle":
      "Réservez avec 1 $. Obtenez le tarif Early Bird, un accès prioritaire et une carte de sauvegarde NFC offerte.",
    "lukkey.hero.heroCtaLabel": "Réserver pour 1 $",
    "lukkey.hero.heroCtaNote": "Entièrement remboursable. Sans engagement d'achat.",
    "lukkey.hero.buy": "Réserver Lukkey pour 1 $",
    "lukkey.hero.buyWithPrice": "Réserver Lukkey pour {{price}}",
    "lukkey.hero.swissBadgeLabel": "Marque suisse",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet crypto hors ligne avec accès par empreinte",
    "lukkey.seo.description": "LUKKEY est un portefeuille matériel suisse conçu pour une auto-garde sécurisée, avec protection hors ligne des clés privées, puce sécurisée EAL6+, accès par empreinte, sauvegarde NFC et prise en charge de plusieurs portefeuilles indépendants.",
    "lukkey.seoIntent.eyebrow": "Guide des portefeuilles matériels",
    "lukkey.seoIntent.title": "Pourquoi les utilisateurs recherchent un cold wallet comme LUKKEY",
    "lukkey.seoIntent.intro": "Un portefeuille matériel doit faire plus que sembler sécurisé. Il doit garder les clés privées hors ligne, rendre la récupération plus pratique et offrir aux détenteurs long terme un parcours de self-custody plus clair.",
    "lukkey.seoIntent.cards.offline.title": "Stockage hors ligne des clés privées",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY est conçu comme un portefeuille matériel qui garde les clés privées hors ligne au lieu de les laisser exposées dans un navigateur, un exchange ou une application toujours connectée.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Pour les détenteurs long terme et les utilisateurs crypto exigeants, un cold wallet réduit la surface d’attaque à distance et donne un contrôle plus direct que le stockage sur des exchanges ou des wallets logiciels seuls.",
    "lukkey.seoIntent.cards.recovery.title": "Accès par empreinte et sauvegarde NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY associe une sécurité centrée sur le matériel à des outils de récupération pratiques, dont l’accès par empreinte au quotidien et des flux de sauvegarde NFC pensés pour une auto-garde plus sûre.",
    "lukkey.seoIntent.cards.fit.title": "Conçu pour une auto-garde sécurisée",
    "lukkey.seoIntent.cards.fit.body": "Si vous cherchez un portefeuille matériel pour Bitcoin, Ethereum, USDT et la gestion multi-comptes crypto, LUKKEY est conçu autour de la confidentialité, de la séparation et du contrôle long terme.",
    "lukkey.highlights.title": "Découvrez les points forts de Lukkey.",
    "lukkey.physical.title": "La sécurité, gravée dans le silicium.",
    "lukkey.physical.subtitle":
      "Une architecture de sécurité matérielle fondée sur plusieurs éléments sécurisés, ancrée par une racine de confiance EAL6+ et renforcée par une conception structurelle et électronique résistante aux altérations.",
    "lukkey.design.title": "Le design n’est pas une décoration, c’est une preuve de crédibilité",
    "lukkey.design.description":
      "Un design industriel au niveau des prix iF et Red Dot, mettant en valeur les arêtes chanfreinées et les reflets subtils du verre.",
    "lukkey.reliability.title": "Étanchéité IP68\nProtection anti-poussière IP6X",
    "lukkey.reliability.description":
      "Étanchéité IP68 et protection anti-poussière IP6X, conçues pour bloquer l’eau et les particules fines dans les environnements difficiles.",
    "lukkey.reliability.canvasLine1": "Étanchéité IP68",
    "lukkey.reliability.canvasLine2": "Protection anti-poussière IP6X",
    "lukkey.system.title": "Mode sûr",
    "lukkey.system.description":
      "Une couche de protection discrète pour les situations sensibles.\n\nSafenotes déguise l’interface du portefeuille en page de notes,\ntandis que seul le compte actif reste visible.\nLes opérations sensibles, comme la suppression d’un compte unique, sont restreintes.",
    "lukkey.system.multiAccountTitle":
      "Prise en charge de 3 phrases de récupération indépendantes",
    "lukkey.system.multiAccountDescription":
      "Créez jusqu’à trois portefeuilles totalement indépendants, chacun protégé par sa propre phrase de récupération. Séparez actifs, stratégies ou identités tout en gardant un contrôle total sur vos actifs numériques.",
    "lukkey.daily.title": "Déverrouillage par empreinte",
    "lukkey.daily.description":
      "Déverrouillez instantanément votre portefeuille grâce à l’authentification par empreinte digitale.\n\nRapide, fluide et vérifié directement sur l’appareil.",
    "lukkey.capability.title": "Prise en charge des NFT",
    "lukkey.capability.description":
      "Un espace d’affichage d’actifs en environnement sombre, avec des cartes aux reflets de verre et une faible saturation pour mettre en avant la propriété et le contrôle.",
    "lukkey.backup.title": "Carte de sauvegarde NFC",
    "lukkey.backup.description":
      "Une carte de sauvegarde NFC avec élément sécurisé EAL6+.\nTouchez simplement l’appareil pour sauvegarder ou importer vos phrases de récupération en toute sécurité.",
    "lukkey.trust.title": "Sécurité ouverte et vérifiable",
    "lukkey.trust.description":
      "Reposant sur un élément sécurisé EAL6+ et une architecture open source,\nLUKKEY permet une vérification indépendante de la sécurité matérielle comme logicielle.\n\nLa génération, le stockage et la signature des clés restent protégés à l’intérieur de l’appareil,\ntandis que le code open source permet une revue de sécurité transparente par la communauté.\n\nUne sécurité que vous pouvez vérifier. Un contrôle qui reste le vôtre.",
    "lukkey.video.title": "Conçu pour protéger. Pensé pour durer.",
    "lukkey.video.description":
      "Fabriqué avec la précision suisse et obsédé par la sécurité, LUKKEY est le portefeuille froid pour ceux qui exigent un contrôle total.",
    "lukkey.values.privacy.title": "Confidentialité",
    "lukkey.values.privacy.description":
      "Vos clés ne quittent jamais l’appareil. La signature air-gapped maintient les opérations sensibles totalement hors ligne.",
    "lukkey.values.inclusive.title": "Design inclusif",
    "lukkey.values.inclusive.description":
      "Un design centré sur l’humain, clair pour les débutants et efficace pour les experts.",
    "lukkey.values.secure.title": "Sécurité",
    "lukkey.values.secure.description":
      "Une protection matérielle renforcée par plusieurs couches contre l’altération, l’extraction et l’usurpation.",
    "lukkey.values.environment.title": "Durabilité",
    "lukkey.values.environment.description":
      "Pensé pour durer avec des matériaux robustes, une structure réparable et moins de déchets liés au remplacement.",
    "lukkey.contact.title": "Restons en contact",
    "lukkey.contact.announcements":
      "Les annonces sont disponibles sur notre blog.",
    "lukkey.contact.pressLabel": "Contact presse :",
  },
  de: {
    "lukkey.hero.subtitle": "Deine Assets, deine Kontrolle.",
    "lukkey.hero.reserveSubtitle":
      "Reserviere für 1 $. Erhalte den Early-Bird-Preis, bevorzugten Zugang und eine kostenlose NFC-Backup-Karte.",
    "lukkey.hero.heroCtaLabel": "Für 1 $ reservieren",
    "lukkey.hero.heroCtaNote": "Voll erstattbar. Keine Kaufverpflichtung.",
    "lukkey.hero.buy": "Lukkey für 1 $ reservieren",
    "lukkey.hero.buyWithPrice": "Lukkey für {{price}} reservieren",
    "lukkey.hero.swissBadgeLabel": "Schweizer Marke",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Offline-Krypto-Cold-Wallet mit Fingerabdruckzugang",
    "lukkey.seo.description": "LUKKEY ist eine Schweizer Hardware-Wallet für sichere Selbstverwahrung mit Offline-Schutz privater Schlüssel, EAL6+-Sicherheitschip, Fingerabdruckzugang, NFC-Backup und Unterstützung mehrerer unabhängiger Wallets.",
    "lukkey.seoIntent.eyebrow": "Hardware-Wallet-Leitfaden",
    "lukkey.seoIntent.title": "Warum Nutzer nach einer Cold Wallet wie LUKKEY suchen",
    "lukkey.seoIntent.intro": "Eine Hardware-Wallet sollte mehr leisten, als nur sicher auszusehen. Sie sollte private Schlüssel offline halten, die Wiederherstellung praktikabel machen und Langzeit-Haltern einen klareren Self-Custody-Workflow geben.",
    "lukkey.seoIntent.cards.offline.title": "Offline-Speicherung privater Schlüssel",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY ist als Hardware-Wallet konzipiert, die private Schlüssel offline hält, statt sie in einem Browser, auf einer Börse oder in einer dauerhaft verbundenen App offenzulegen.",
    "lukkey.seoIntent.cards.compare.title": "Cold Wallet vs. Hot Wallet",
    "lukkey.seoIntent.cards.compare.body": "Für Langzeit-Halter und anspruchsvolle Krypto-Nutzer reduziert eine Cold Wallet die entfernte Angriffsfläche und bietet direktere Kontrolle als die Aufbewahrung auf Börsen oder reinen Software-Wallets.",
    "lukkey.seoIntent.cards.recovery.title": "Fingerabdruckzugang und NFC-Backup",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY verbindet hardwarebasierte Sicherheit mit praktischen Wiederherstellungstools, darunter Fingerabdruckzugang für den Alltag und NFC-Backup-Abläufe für sicherere Selbstverwahrung.",
    "lukkey.seoIntent.cards.fit.title": "Für sichere Selbstverwahrung entwickelt",
    "lukkey.seoIntent.cards.fit.body": "Wenn du eine Hardware-Wallet für Bitcoin, Ethereum, USDT und Multi-Account-Krypto-Management suchst, ist LUKKEY auf Privatsphäre, Trennung und langfristige Kontrolle ausgelegt.",
    "lukkey.highlights.title": "Entdecke die Highlights von Lukkey.",
    "lukkey.physical.title": "Sicherheit, im Silizium verankert.",
    "lukkey.physical.subtitle":
      "Eine Hardware-Sicherheitsarchitektur auf Basis mehrerer Secure Elements, verankert durch eine EAL6+-Root-of-Trust und verstärkt durch manipulationsresistente Schaltungs- und Strukturkonstruktion.",
    "lukkey.design.title": "Design ist keine Dekoration, sondern Glaubwürdigkeit",
    "lukkey.design.description":
      "Industriedesign auf iF- und Red-Dot-Niveau mit Fokus auf gefaste Kanten und subtile Glasreflexe.",
    "lukkey.reliability.title": "IP68 wasserdicht\nIP6X staubdicht",
    "lukkey.reliability.description":
      "IP68-Wasserschutz und IP6X-Staubschutz, entwickelt, um Wasser und feine Partikel auch in rauen Umgebungen zuverlässig abzuwehren.",
    "lukkey.reliability.canvasLine1": "IP68 wasserdicht",
    "lukkey.reliability.canvasLine2": "IP6X staubdicht",
    "lukkey.system.title": "Sicherheitsmodus",
    "lukkey.system.description":
      "Eine diskrete Schutzebene für sensible Situationen.\n\nSafenotes tarnt die Wallet-Oberfläche als Notizseite,\nwährend nur das aktive Konto sichtbar bleibt.\nSensible Vorgänge wie das Löschen eines einzelnen Kontos sind eingeschränkt.",
    "lukkey.system.multiAccountTitle":
      "Unterstützung für 3 unabhängige Recovery-Phrasen",
    "lukkey.system.multiAccountDescription":
      "Erstelle bis zu drei vollständig unabhängige Wallets, jeweils mit eigener Recovery-Phrase gesichert. Trenne Vermögen, Strategien oder Identitäten und behalte dabei die volle Kontrolle über deine digitalen Assets.",
    "lukkey.daily.title": "Fingerabdruck-Entsperrung",
    "lukkey.daily.description":
      "Entsperre deine Wallet sofort per Fingerabdruck.\n\nSchnell, nahtlos und direkt auf dem Gerät verifiziert.",
    "lukkey.capability.title": "NFT-Unterstützung",
    "lukkey.capability.description":
      "Ein dunkler Ausstellungsraum für Assets mit glasartigen Karten und geringer Sättigung, um Besitz und Kontrolle zu betonen.",
    "lukkey.backup.title": "NFC-Backup-Karte",
    "lukkey.backup.description":
      "Eine NFC-Backup-Karte mit EAL6+-Secure-Element.\nEinfach das Gerät antippen, um Recovery-Phrasen sicher zu sichern oder zu importieren.",
    "lukkey.trust.title": "Offene und verifizierbare Sicherheit",
    "lukkey.trust.description":
      "Basierend auf einem EAL6+-Secure-Element und einer Open-Source-Architektur\nermöglicht LUKKEY die unabhängige Überprüfung von Hardware- und Softwaresicherheit.\n\nSchlüsselerzeugung, Speicherung und Signierung bleiben im Gerät geschützt,\nwährend Open-Source-Code eine transparente Sicherheitsprüfung durch die Community ermöglicht.\n\nSicherheit, die du überprüfen kannst. Kontrolle, die dir gehört.",
    "lukkey.video.title": "Entwickelt zum Schutz. Gemacht für Dauer.",
    "lukkey.video.description":
      "Mit Schweizer Präzision gefertigt und kompromisslos sicherheitsorientiert ist LUKKEY die Cold Wallet für alle, die totale Kontrolle verlangen.",
    "lukkey.values.privacy.title": "Privatsphäre",
    "lukkey.values.privacy.description":
      "Deine Schlüssel verlassen das Gerät nie. Air-gapped-Signierung hält sensible Vorgänge vollständig offline.",
    "lukkey.values.inclusive.title": "Inklusives Design",
    "lukkey.values.inclusive.description":
      "Menschenzentriertes Design, klar für Einsteiger und effizient für Profis.",
    "lukkey.values.secure.title": "Sicher",
    "lukkey.values.secure.description":
      "Hardwaregestützter Schutz mit mehreren Sicherheitsebenen gegen Manipulation, Extraktion und Spoofing.",
    "lukkey.values.environment.title": "Nachhaltigkeit",
    "lukkey.values.environment.description":
      "Für langfristige Nutzung gebaut, mit langlebigen Materialien, reparaturfreundlicher Struktur und weniger Austauschabfall.",
    "lukkey.contact.title": "In Kontakt bleiben",
    "lukkey.contact.announcements": "Ankündigungen findest du in unserem Blog.",
    "lukkey.contact.pressLabel": "Pressekontakt:",
  },
  it: {
    "lukkey.hero.subtitle": "I tuoi asset, il tuo controllo.",
    "lukkey.hero.reserveSubtitle":
      "Prenota con 1 $. Ottieni il prezzo Early Bird, accesso prioritario e una scheda NFC di backup gratuita.",
    "lukkey.hero.heroCtaLabel": "Prenota con 1 $",
    "lukkey.hero.heroCtaNote": "Completamente rimborsabile. Nessun impegno all'acquisto.",
    "lukkey.hero.buy": "Prenota Lukkey con 1 $",
    "lukkey.hero.buyWithPrice": "Prenota Lukkey con {{price}}",
    "lukkey.hero.swissBadgeLabel": "Marchio svizzero",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet crypto offline con accesso tramite impronta",
    "lukkey.seo.description": "LUKKEY è un hardware wallet svizzero pensato per una self-custody sicura, con protezione offline delle chiavi private, chip sicuro EAL6+, accesso tramite impronta, backup NFC e supporto per più wallet indipendenti.",
    "lukkey.seoIntent.eyebrow": "Guida agli hardware wallet",
    "lukkey.seoIntent.title": "Perché gli utenti cercano una cold wallet come LUKKEY",
    "lukkey.seoIntent.intro": "Un hardware wallet deve fare più che sembrare sicuro. Deve mantenere le chiavi private offline, rendere il recupero pratico e offrire ai possessori di lungo periodo un percorso di self-custody più chiaro.",
    "lukkey.seoIntent.cards.offline.title": "Archiviazione offline delle chiavi private",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY è progettato come hardware wallet che mantiene le chiavi private offline invece di lasciarle esposte in un browser, su un exchange o in un’app sempre connessa.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Per chi detiene crypto a lungo termine e per gli utenti più attenti alla sicurezza, una cold wallet riduce la superficie di attacco remota e offre un controllo più diretto rispetto a exchange o software wallet.",
    "lukkey.seoIntent.cards.recovery.title": "Accesso con impronta e backup NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY unisce sicurezza hardware-first a strumenti di recupero pratici, inclusi accesso con impronta per l’uso quotidiano e flussi di backup NFC pensati per una self-custody più sicura.",
    "lukkey.seoIntent.cards.fit.title": "Progettato per una self-custody sicura",
    "lukkey.seoIntent.cards.fit.body": "Se stai cercando un hardware wallet per Bitcoin, Ethereum, USDT e gestione multi-account, LUKKEY è progettato attorno a privacy, separazione e controllo nel lungo periodo.",
    "lukkey.highlights.title": "Scopri i punti chiave di Lukkey.",
    "lukkey.physical.title": "Sicurezza, integrata nel silicio.",
    "lukkey.physical.subtitle":
      "Un’architettura di sicurezza hardware costruita su più elementi sicuri, ancorata a una root of trust EAL6+ e rafforzata da circuiti e struttura resistenti alle manomissioni.",
    "lukkey.design.title": "Il design non è decorazione, è credibilità",
    "lukkey.design.description":
      "Design industriale con una cura artigianale da livello iF e Red Dot, che valorizza bordi smussati e delicati riflessi del vetro.",
    "lukkey.reliability.title": "Impermeabilità IP68\nProtezione antipolvere IP6X",
    "lukkey.reliability.description":
      "Impermeabilità IP68 e protezione antipolvere IP6X, progettate per bloccare acqua e particelle fini negli ambienti più difficili.",
    "lukkey.reliability.canvasLine1": "Impermeabilità IP68",
    "lukkey.reliability.canvasLine2": "Protezione antipolvere IP6X",
    "lukkey.system.title": "Modalità sicura",
    "lukkey.system.description":
      "Uno strato di protezione discreto per situazioni sensibili.\n\nSafenotes maschera l’interfaccia del wallet come una pagina di note,\nmentre solo l’account attivo resta visibile.\nLe operazioni sensibili, come l’eliminazione di un singolo account, sono limitate.",
    "lukkey.system.multiAccountTitle":
      "Supporto per 3 frasi di recupero indipendenti",
    "lukkey.system.multiAccountDescription":
      "Crea fino a tre wallet completamente indipendenti, ciascuno protetto dalla propria frase di recupero. Separa asset, strategie o identità mantenendo il pieno controllo dei tuoi asset digitali.",
    "lukkey.daily.title": "Sblocco con impronta",
    "lukkey.daily.description":
      "Sblocca il tuo wallet all’istante con l’autenticazione tramite impronta digitale.\n\nRapido, fluido e verificato direttamente sul dispositivo.",
    "lukkey.capability.title": "Supporto NFT",
    "lukkey.capability.description":
      "Uno spazio espositivo in ambiente scuro con carte dall’effetto vetro e colori poco saturi per enfatizzare proprietà e controllo.",
    "lukkey.backup.title": "Scheda NFC di backup",
    "lukkey.backup.description":
      "Una scheda NFC di backup con secure element EAL6+.\nBasta toccare il dispositivo per eseguire il backup o importare in sicurezza le frasi di recupero.",
    "lukkey.trust.title": "Sicurezza aperta e verificabile",
    "lukkey.trust.description":
      "Basato su un secure element EAL6+ e un’architettura open-source,\nLUKKEY consente la verifica indipendente della sicurezza hardware e software.\n\nLa generazione, la conservazione e la firma delle chiavi restano protette all’interno del dispositivo,\nmentre il codice open-source permette una revisione trasparente della sicurezza da parte della comunità.\n\nSicurezza verificabile. Controllo che resta tuo.",
    "lukkey.video.title": "Creato per proteggere. Progettato per durare.",
    "lukkey.video.description":
      "Realizzato con precisione svizzera e ossessionato dalla sicurezza, LUKKEY è il cold wallet per chi pretende controllo totale.",
    "lukkey.values.privacy.title": "Privacy",
    "lukkey.values.privacy.description":
      "Le tue chiavi non lasciano mai il dispositivo. La firma air-gapped mantiene completamente offline le operazioni sensibili.",
    "lukkey.values.inclusive.title": "Design inclusivo",
    "lukkey.values.inclusive.description":
      "Design centrato sulle persone, chiaro per i principianti ed efficiente per gli esperti.",
    "lukkey.values.secure.title": "Sicuro",
    "lukkey.values.secure.description":
      "Protezione basata su hardware con più livelli di difesa contro manomissioni, estrazione e spoofing.",
    "lukkey.values.environment.title": "Sostenibilità",
    "lukkey.values.environment.description":
      "Pensato per un uso duraturo con materiali resistenti, struttura riparabile e meno sprechi da sostituzione.",
    "lukkey.contact.title": "Rimani in contatto",
    "lukkey.contact.announcements":
      "Gli annunci sono disponibili sul nostro blog.",
    "lukkey.contact.pressLabel": "Contatto stampa:",
  },
  pt: {
    "lukkey.hero.subtitle": "Seus ativos, seu controle.",
    "lukkey.hero.reserveSubtitle":
      "Reserve com US$ 1. Garanta o preço Early Bird, acesso prioritário e um cartão NFC de backup grátis.",
    "lukkey.hero.heroCtaLabel": "Reserve por US$ 1",
    "lukkey.hero.heroCtaNote": "Totalmente reembolsável. Sem compromisso de compra.",
    "lukkey.hero.buy": "Reserve Lukkey com US$ 1",
    "lukkey.hero.buyWithPrice": "Reserve Lukkey por {{price}}",
    "lukkey.hero.swissBadgeLabel": "Marca suíça",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet cripto offline com acesso por impressão digital",
    "lukkey.seo.description": "A LUKKEY é uma carteira de hardware suíça criada para uma autocustódia segura, com proteção offline de chaves privadas, chip seguro EAL6+, acesso por impressão digital, backup NFC e suporte para várias carteiras independentes.",
    "lukkey.seoIntent.eyebrow": "Guia de carteiras de hardware",
    "lukkey.seoIntent.title": "Porque as pessoas procuram uma cold wallet como a LUKKEY",
    "lukkey.seoIntent.intro": "Uma carteira de hardware deve fazer mais do que parecer segura. Deve manter as chaves privadas offline, tornar a recuperação prática e dar aos holders de longo prazo um fluxo de autocustódia mais claro.",
    "lukkey.seoIntent.cards.offline.title": "Armazenamento offline de chaves privadas",
    "lukkey.seoIntent.cards.offline.body": "A LUKKEY foi concebida como uma carteira de hardware que mantém as chaves privadas offline em vez de as deixar expostas num navegador, exchange ou app sempre ligada.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Para holders de longo prazo e utilizadores cripto exigentes, uma cold wallet reduz a superfície de ataque remota e oferece controlo mais direto do que deixar ativos apenas em exchanges ou software wallets.",
    "lukkey.seoIntent.cards.recovery.title": "Acesso por impressão digital e backup NFC",
    "lukkey.seoIntent.cards.recovery.body": "A LUKKEY combina segurança centrada no hardware com ferramentas de recuperação práticas, incluindo acesso por impressão digital para o uso diário e fluxos de backup NFC pensados para uma autocustódia mais segura.",
    "lukkey.seoIntent.cards.fit.title": "Feita para autocustódia segura",
    "lukkey.seoIntent.cards.fit.body": "Se procura uma carteira de hardware para Bitcoin, Ethereum, USDT e gestão de múltiplas contas cripto, a LUKKEY foi desenhada em torno de privacidade, separação e controlo a longo prazo.",
    "lukkey.highlights.title": "Veja os destaques da Lukkey.",
    "lukkey.physical.title": "Segurança, gravada no silício.",
    "lukkey.physical.subtitle":
      "Uma arquitetura de segurança em hardware construída sobre múltiplos elementos seguros, ancorada por uma raiz de confiança EAL6+ e reforçada por circuitos e estrutura resistentes a violação.",
    "lukkey.design.title": "Design não é decoração, é credibilidade",
    "lukkey.design.description":
      "Design industrial com acabamento em nível iF e Red Dot, destacando bordas chanfradas e reflexos sutis no vidro.",
    "lukkey.reliability.title": "Proteção IP68 contra água\nProteção IP6X contra poeira",
    "lukkey.reliability.description":
      "Proteção IP68 contra água e proteção IP6X contra poeira, projetadas para bloquear a entrada de água e partículas finas em ambientes severos.",
    "lukkey.reliability.canvasLine1": "Proteção IP68 contra água",
    "lukkey.reliability.canvasLine2": "Proteção IP6X contra poeira",
    "lukkey.system.title": "Modo seguro",
    "lukkey.system.description":
      "Uma camada discreta de proteção para situações sensíveis.\n\nSafenotes disfarça a interface da carteira como uma página de notas,\nenquanto apenas a conta ativa permanece visível.\nOperações sensíveis, como excluir uma única conta, ficam restritas.",
    "lukkey.system.multiAccountTitle":
      "Suporte para 3 frases de recuperação independentes",
    "lukkey.system.multiAccountDescription":
      "Crie até três carteiras totalmente independentes, cada uma protegida por sua própria frase de recuperação. Separe ativos, estratégias ou identidades mantendo controle total sobre seus ativos digitais.",
    "lukkey.daily.title": "Desbloqueio por impressão digital",
    "lukkey.daily.description":
      "Desbloqueie sua carteira instantaneamente com autenticação por impressão digital.\n\nRápido, fluido e verificado diretamente no dispositivo.",
    "lukkey.capability.title": "Suporte a NFT",
    "lukkey.capability.description":
      "Uma vitrine de ativos em espaço escuro com cartões vítreos e baixa saturação para destacar propriedade e controle.",
    "lukkey.backup.title": "Cartão NFC de backup",
    "lukkey.backup.description":
      "Um cartão NFC de backup com elemento seguro EAL6+.\nBasta tocar o dispositivo para fazer backup ou importar frases de recuperação com segurança.",
    "lukkey.trust.title": "Segurança aberta e verificável",
    "lukkey.trust.description":
      "Baseado em um elemento seguro EAL6+ e em uma arquitetura open source,\no LUKKEY permite que a segurança de hardware e software seja verificada de forma independente.\n\nA geração, o armazenamento e a assinatura de chaves permanecem protegidos dentro do dispositivo,\nenquanto o código aberto permite revisão transparente de segurança pela comunidade.\n\nSegurança que você pode verificar. Controle que continua sendo seu.",
    "lukkey.video.title": "Feito para proteger. Projetado para durar.",
    "lukkey.video.description":
      "Com fabricação suíça e obsessão por segurança, LUKKEY é a cold wallet para quem exige controle total.",
    "lukkey.values.privacy.title": "Privacidade",
    "lukkey.values.privacy.description":
      "Suas chaves nunca saem do dispositivo. A assinatura air-gapped mantém operações sensíveis totalmente offline.",
    "lukkey.values.inclusive.title": "Design inclusivo",
    "lukkey.values.inclusive.description":
      "Design centrado no ser humano, claro para iniciantes e eficiente para especialistas.",
    "lukkey.values.secure.title": "Segurança",
    "lukkey.values.secure.description":
      "Proteção baseada em hardware com múltiplas camadas contra violação, extração e spoofing.",
    "lukkey.values.environment.title": "Sustentabilidade",
    "lukkey.values.environment.description":
      "Construído para uso de longo prazo com materiais duráveis, estrutura reparável e menos desperdício de substituição.",
    "lukkey.contact.title": "Mantenha contato",
    "lukkey.contact.announcements": "Os anúncios podem ser encontrados em nosso blog.",
    "lukkey.contact.pressLabel": "Contato de imprensa:",
  },
  "pt-BR": {
    "lukkey.hero.subtitle": "Seus ativos, seu controle.",
    "lukkey.hero.reserveSubtitle":
      "Reserve com US$ 1. Garanta o preço Early Bird, acesso prioritário e um cartão NFC de backup grátis.",
    "lukkey.hero.heroCtaLabel": "Reserve por US$ 1",
    "lukkey.hero.heroCtaNote": "Totalmente reembolsável. Sem compromisso de compra.",
    "lukkey.hero.buy": "Reserve Lukkey com US$ 1",
    "lukkey.hero.buyWithPrice": "Reserve Lukkey por {{price}}",
    "lukkey.hero.swissBadgeLabel": "Marca suíça",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet cripto offline com acesso por impressão digital",
    "lukkey.seo.description": "A LUKKEY é uma carteira de hardware suíça criada para uma autocustódia segura, com proteção offline de chaves privadas, chip seguro EAL6+, acesso por impressão digital, backup NFC e suporte para várias carteiras independentes.",
    "lukkey.seoIntent.eyebrow": "Guia de carteiras de hardware",
    "lukkey.seoIntent.title": "Por que as pessoas procuram uma cold wallet como a LUKKEY",
    "lukkey.seoIntent.intro": "Uma carteira de hardware precisa fazer mais do que parecer segura. Ela deve manter as chaves privadas offline, tornar a recuperação prática e oferecer aos holders de longo prazo um fluxo de autocustódia mais claro.",
    "lukkey.seoIntent.cards.offline.title": "Armazenamento offline de chaves privadas",
    "lukkey.seoIntent.cards.offline.body": "A LUKKEY foi projetada como uma carteira de hardware que mantém as chaves privadas offline, em vez de deixá-las expostas em um navegador, exchange ou app sempre conectada.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Para holders de longo prazo e usuários cripto mais exigentes, uma cold wallet reduz a superfície de ataque remota e oferece controle mais direto do que deixar ativos apenas em exchanges ou wallets de software.",
    "lukkey.seoIntent.cards.recovery.title": "Acesso por impressão digital e backup NFC",
    "lukkey.seoIntent.cards.recovery.body": "A LUKKEY combina segurança orientada por hardware com ferramentas práticas de recuperação, incluindo acesso por impressão digital para o uso diário e fluxos de backup NFC pensados para uma autocustódia mais segura.",
    "lukkey.seoIntent.cards.fit.title": "Feita para autocustódia segura",
    "lukkey.seoIntent.cards.fit.body": "Se você procura uma carteira de hardware para Bitcoin, Ethereum, USDT e gestão de múltiplas contas cripto, a LUKKEY foi projetada com foco em privacidade, separação e controle de longo prazo.",
    "lukkey.highlights.title": "Veja os destaques da Lukkey.",
    "lukkey.physical.title": "Segurança, gravada no silício.",
    "lukkey.physical.subtitle":
      "Uma arquitetura de segurança em hardware construída sobre múltiplos elementos seguros, ancorada por uma raiz de confiança EAL6+ e reforçada por circuitos e estrutura resistentes a violação.",
    "lukkey.design.title": "Design não é decoração, é credibilidade",
    "lukkey.design.description":
      "Design industrial com acabamento em nível iF e Red Dot, destacando bordas chanfradas e reflexos sutis no vidro.",
    "lukkey.reliability.title": "Proteção IP68 contra água\nProteção IP6X contra poeira",
    "lukkey.reliability.description":
      "Proteção IP68 contra água e proteção IP6X contra poeira, projetadas para bloquear a entrada de água e partículas finas em ambientes severos.",
    "lukkey.reliability.canvasLine1": "Proteção IP68 contra água",
    "lukkey.reliability.canvasLine2": "Proteção IP6X contra poeira",
    "lukkey.system.title": "Modo seguro",
    "lukkey.system.description":
      "Uma camada discreta de proteção para situações sensíveis.\n\nSafenotes disfarça a interface da carteira como uma página de notas,\nenquanto apenas a conta ativa permanece visível.\nOperações sensíveis, como excluir uma única conta, ficam restritas.",
    "lukkey.system.multiAccountTitle":
      "Suporte para 3 frases de recuperação independentes",
    "lukkey.system.multiAccountDescription":
      "Crie até três carteiras totalmente independentes, cada uma protegida por sua própria frase de recuperação. Separe ativos, estratégias ou identidades mantendo controle total sobre seus ativos digitais.",
    "lukkey.daily.title": "Desbloqueio por impressão digital",
    "lukkey.daily.description":
      "Desbloqueie sua carteira instantaneamente com autenticação por impressão digital.\n\nRápido, fluido e verificado diretamente no dispositivo.",
    "lukkey.capability.title": "Suporte a NFT",
    "lukkey.capability.description":
      "Uma vitrine de ativos em espaço escuro com cartões vítreos e baixa saturação para destacar propriedade e controle.",
    "lukkey.backup.title": "Cartão NFC de backup",
    "lukkey.backup.description":
      "Um cartão NFC de backup com elemento seguro EAL6+.\nBasta tocar o dispositivo para fazer backup ou importar frases de recuperação com segurança.",
    "lukkey.trust.title": "Segurança aberta e verificável",
    "lukkey.trust.description":
      "Baseado em um elemento seguro EAL6+ e em uma arquitetura open source,\no LUKKEY permite que a segurança de hardware e software seja verificada de forma independente.\n\nA geração, o armazenamento e a assinatura de chaves permanecem protegidos dentro do dispositivo,\nenquanto o código aberto permite revisão transparente de segurança pela comunidade.\n\nSegurança que você pode verificar. Controle que continua sendo seu.",
    "lukkey.video.title": "Feito para proteger. Projetado para durar.",
    "lukkey.video.description":
      "Com fabricação suíça e obsessão por segurança, LUKKEY é a cold wallet para quem exige controle total.",
    "lukkey.values.privacy.title": "Privacidade",
    "lukkey.values.privacy.description":
      "Suas chaves nunca saem do dispositivo. A assinatura air-gapped mantém operações sensíveis totalmente offline.",
    "lukkey.values.inclusive.title": "Design inclusivo",
    "lukkey.values.inclusive.description":
      "Design centrado no ser humano, claro para iniciantes e eficiente para especialistas.",
    "lukkey.values.secure.title": "Segurança",
    "lukkey.values.secure.description":
      "Proteção baseada em hardware com múltiplas camadas contra violação, extração e spoofing.",
    "lukkey.values.environment.title": "Sustentabilidade",
    "lukkey.values.environment.description":
      "Construído para uso de longo prazo com materiais duráveis, estrutura reparável e menos desperdício de substituição.",
    "lukkey.contact.title": "Mantenha contato",
    "lukkey.contact.announcements": "Os anúncios podem ser encontrados em nosso blog.",
    "lukkey.contact.pressLabel": "Contato de imprensa:",
  },
  ja: {
    "lukkey.hero.subtitle": "あなたの資産、あなたの管理。",
    "lukkey.hero.reserveSubtitle":
      "1ドルで予約。Early Bird価格、優先アクセス、無料のNFCバックアップカードを利用できます。",
    "lukkey.hero.heroCtaLabel": "1ドルで予約",
    "lukkey.hero.heroCtaNote": "全額返金可能。購入の約束は不要です。",
    "lukkey.hero.buy": "1ドルでLukkeyを予約",
    "lukkey.hero.buyWithPrice": "{{price}}でLukkeyを予約",
    "lukkey.hero.swissBadgeLabel": "スイスブランド",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | 指紋認証対応のオフライン暗号資産コールドウォレット",
    "lukkey.seo.description": "LUKKEY は、安全なセルフカストディのために設計されたスイス製ハードウェアウォレットで、秘密鍵のオフライン保護、EAL6+ セキュアチップ、指紋認証、NFC バックアップ、複数の独立ウォレット対応を備えています。",
    "lukkey.seoIntent.eyebrow": "ハードウェアウォレットガイド",
    "lukkey.seoIntent.title": "なぜユーザーは LUKKEY のようなコールドウォレットを探すのか",
    "lukkey.seoIntent.intro": "ハードウェアウォレットは、単に安全に見えるだけでは不十分です。秘密鍵をオフラインに保ち、復元を実用的にし、長期保有者により明確なセルフカストディの流れを提供する必要があります。",
    "lukkey.seoIntent.cards.offline.title": "秘密鍵のオフライン保管",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY は、秘密鍵をブラウザ、取引所、常時接続のアプリ環境にさらすのではなく、オフラインに保つハードウェアウォレットとして設計されています。",
    "lukkey.seoIntent.cards.compare.title": "コールドウォレットとホットウォレットの違い",
    "lukkey.seoIntent.cards.compare.body": "長期保有者や安全性を重視する暗号資産ユーザーにとって、コールドウォレットはリモート攻撃の対象を減らし、取引所やソフトウェアウォレットだけに置くよりも高いコントロールを提供します。",
    "lukkey.seoIntent.cards.recovery.title": "指紋認証と NFC バックアップ",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY は、ハードウェア中心のセキュリティと実用的な復元手段を組み合わせ、日常利用向けの指紋認証と、より安全なセルフカストディのための NFC バックアップフローを提供します。",
    "lukkey.seoIntent.cards.fit.title": "安全なセルフカストディのために設計",
    "lukkey.seoIntent.cards.fit.body": "Bitcoin、Ethereum、USDT、複数アカウント管理に対応するハードウェアウォレットを探しているなら、LUKKEY はプライバシー、分離、長期的なコントロールを重視して設計されています。",
    "lukkey.highlights.title": "Lukkey の主な特長をご覧ください。",
    "lukkey.physical.title": "セキュリティは、シリコンに組み込まれている。",
    "lukkey.physical.subtitle":
      "複数のセキュアエレメントを基盤とし、EAL6+の信頼の根を中心に、耐改ざん回路と構造設計で強化されたハードウェアセキュリティアーキテクチャです。",
    "lukkey.design.title": "デザインは装飾ではなく、信頼性そのもの",
    "lukkey.design.description":
      "iF賞やRed Dot賞級のクラフトマンシップを備えた工業デザイン。面取りされたエッジと繊細なガラス反射を際立たせます。",
    "lukkey.reliability.title": "IP68防水\nIP6X防塵",
    "lukkey.reliability.description":
      "IP68等級の防水性能とIP6X等級の防塵性能により、過酷な環境でも水や微細な粉塵の侵入を防ぐよう設計されています。",
    "lukkey.reliability.canvasLine1": "IP68防水",
    "lukkey.reliability.canvasLine2": "IP6X防塵",
    "lukkey.system.title": "セーフモード",
    "lukkey.system.description":
      "機密性が求められる場面のための、控えめな保護レイヤーです。\n\nSafenotesはウォレット画面をメモ風ページに偽装し、\nアクティブなアカウントだけを表示します。\n単一アカウントの削除などの機密操作も制限されます。",
    "lukkey.system.multiAccountTitle": "3つの独立した復元フレーズに対応",
    "lukkey.system.multiAccountDescription":
      "最大3つの完全に独立したウォレットを作成でき、それぞれが独自の復元フレーズで保護されます。資産、戦略、アイデンティティを分けながら、デジタル資産の完全なコントロールを維持できます。",
    "lukkey.daily.title": "指紋認証でロック解除",
    "lukkey.daily.description":
      "指紋認証でウォレットを即座にロック解除。\n\n高速でシームレス、しかも検証はすべてデバイス上で完結します。",
    "lukkey.capability.title": "NFT対応",
    "lukkey.capability.description":
      "暗い空間のアセットディスプレイベイ。ガラス調カードと低彩度の表現で所有権とコントロールを強調します。",
    "lukkey.backup.title": "NFCバックアップカード",
    "lukkey.backup.description":
      "EAL6+セキュアエレメントを搭載したNFCバックアップカード。\nデバイスにタップするだけで、復元フレーズを安全にバックアップまたはインポートできます。",
    "lukkey.trust.title": "オープンで検証可能なセキュリティ",
    "lukkey.trust.description":
      "EAL6+セキュアエレメントとオープンソースアーキテクチャを基盤に、\nLUKKEYはハードウェアとソフトウェアの両方のセキュリティを独立して検証できるようにします。\n\n鍵生成、保管、署名はすべてデバイス内部で保護され、\nオープンソースコードによってコミュニティによる透明なセキュリティレビューが可能になります。\n\n検証できるセキュリティ。あなたの手に残るコントロール。",
    "lukkey.video.title": "守るために生まれ、長く使うために設計された。",
    "lukkey.video.description":
      "スイス品質のクラフトと徹底したセキュリティ思想。LUKKEYは、完全なコントロールを求める人のためのコールドウォレットです。",
    "lukkey.values.privacy.title": "プライバシー",
    "lukkey.values.privacy.description":
      "鍵がデバイス外に出ることはありません。エアギャップ署名により機密操作は完全にオフラインで行われます。",
    "lukkey.values.inclusive.title": "インクルーシブデザイン",
    "lukkey.values.inclusive.description":
      "人間中心の設計で、初心者にはわかりやすく、上級者には効率的です。",
    "lukkey.values.secure.title": "セキュア",
    "lukkey.values.secure.description":
      "ハードウェアベースの保護と多層防御により、改ざん、抽出、なりすましに対抗します。",
    "lukkey.values.environment.title": "持続性",
    "lukkey.values.environment.description":
      "耐久素材、修理を意識した構造、交換廃棄の削減により、長期使用を前提に設計されています。",
    "lukkey.contact.title": "つながりを保つ",
    "lukkey.contact.announcements": "お知らせはブログでご確認いただけます。",
    "lukkey.contact.pressLabel": "報道関係のお問い合わせ：",
  },
  ko: {
    "lukkey.hero.subtitle": "당신의 자산, 당신의 통제.",
    "lukkey.hero.reserveSubtitle":
      "1달러로 예약하고 얼리버드 가격, 우선 접근 권한, 무료 NFC 백업 카드를 받으세요.",
    "lukkey.hero.heroCtaLabel": "$1로 예약하기",
    "lukkey.hero.heroCtaNote": "전액 환불 가능합니다. 구매 약정은 필요 없습니다.",
    "lukkey.hero.buy": "1달러로 Lukkey 예약하기",
    "lukkey.hero.buyWithPrice": "{{price}}에 Lukkey 예약하기",
    "lukkey.hero.swissBadgeLabel": "스위스 브랜드",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | 지문 접근을 지원하는 오프라인 암호화폐 콜드 월렛",
    "lukkey.seo.description": "LUKKEY는 안전한 셀프 커스터디를 위해 설계된 스위스 하드웨어 월렛으로, 개인 키 오프라인 보호, EAL6+ 보안 칩, 지문 접근, NFC 백업, 다중 독립 지갑 지원을 제공합니다.",
    "lukkey.seoIntent.eyebrow": "하드웨어 월렛 가이드",
    "lukkey.seoIntent.title": "왜 사용자는 LUKKEY 같은 콜드 월렛을 찾는가",
    "lukkey.seoIntent.intro": "하드웨어 월렛은 단지 안전해 보이는 것만으로는 충분하지 않습니다. 개인 키를 오프라인에 유지하고, 복구를 실용적으로 만들며, 장기 보유자에게 더 명확한 셀프 커스터디 흐름을 제공해야 합니다.",
    "lukkey.seoIntent.cards.offline.title": "오프라인 개인 키 보관",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY는 개인 키를 브라우저, 거래소 또는 항상 연결된 앱 환경에 노출하지 않고 오프라인으로 유지하도록 설계된 하드웨어 월렛입니다.",
    "lukkey.seoIntent.cards.compare.title": "콜드 월렛 vs 핫 월렛",
    "lukkey.seoIntent.cards.compare.body": "장기 보유자와 보안을 중시하는 암호화폐 사용자에게 콜드 월렛은 원격 공격 표면을 줄이고, 거래소나 소프트웨어 월렛에만 자산을 두는 것보다 더 직접적인 통제력을 제공합니다.",
    "lukkey.seoIntent.cards.recovery.title": "지문 접근과 NFC 백업",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY는 하드웨어 중심 보안과 실용적인 복구 도구를 결합하여, 일상 사용을 위한 지문 접근과 더 안전한 셀프 커스터디를 위한 NFC 백업 흐름을 제공합니다.",
    "lukkey.seoIntent.cards.fit.title": "안전한 셀프 커스터디를 위해 설계",
    "lukkey.seoIntent.cards.fit.body": "Bitcoin, Ethereum, USDT 및 다중 계정 관리를 위한 하드웨어 월렛을 찾고 있다면, LUKKEY는 프라이버시, 분리, 장기적 통제에 맞춰 설계되었습니다.",
    "lukkey.highlights.title": "Lukkey의 핵심 하이라이트를 확인하세요.",
    "lukkey.physical.title": "보안, 실리콘에 내장되다.",
    "lukkey.physical.subtitle":
      "여러 개의 보안 요소 위에 구축되고 EAL6+ 신뢰 루트를 중심으로 하며, 변조 방지 회로와 구조 설계로 강화된 하드웨어 보안 아키텍처입니다.",
    "lukkey.design.title": "디자인은 장식이 아니라 신뢰성입니다",
    "lukkey.design.description":
      "iF 및 Red Dot 수준의 완성도를 갖춘 산업 디자인으로, 챔퍼 엣지와 섬세한 유리 반사를 강조합니다.",
    "lukkey.reliability.title": "IP68 방수\nIP6X 방진",
    "lukkey.reliability.description":
      "IP68 등급 방수와 IP6X 등급 방진 성능으로, 거친 환경에서도 물과 미세 먼지의 침투를 막도록 설계되었습니다.",
    "lukkey.reliability.canvasLine1": "IP68 방수",
    "lukkey.reliability.canvasLine2": "IP6X 방진",
    "lukkey.system.title": "세이프 모드",
    "lukkey.system.description":
      "민감한 상황을 위한 은밀한 보호 레이어입니다.\n\nSafenotes는 월렛 인터페이스를 메모 스타일 페이지로 위장하고,\n활성 계정만 보이게 합니다.\n단일 계정 삭제 같은 민감한 작업도 제한됩니다.",
    "lukkey.system.multiAccountTitle": "3개의 독립된 복구 문구 지원",
    "lukkey.system.multiAccountDescription":
      "최대 3개의 완전히 독립된 월렛을 생성할 수 있으며, 각 월렛은 자체 복구 문구로 보호됩니다. 자산, 전략 또는 신원을 분리하면서도 디지털 자산에 대한 완전한 통제권을 유지하세요.",
    "lukkey.daily.title": "지문 잠금 해제",
    "lukkey.daily.description":
      "지문 인증으로 즉시 월렛을 잠금 해제하세요.\n\n빠르고 매끄러우며, 모든 검증은 기기에서 직접 수행됩니다.",
    "lukkey.capability.title": "NFT 지원",
    "lukkey.capability.description":
      "어두운 공간의 자산 디스플레이 베이로, 유리감 있는 카드와 낮은 채도로 소유권과 통제감을 강조합니다.",
    "lukkey.backup.title": "NFC 백업 카드",
    "lukkey.backup.description":
      "EAL6+ 보안 요소가 탑재된 NFC 백업 카드.\n기기에 가볍게 터치하기만 하면 복구 문구를 안전하게 백업하거나 가져올 수 있습니다.",
    "lukkey.trust.title": "개방적이고 검증 가능한 보안",
    "lukkey.trust.description":
      "EAL6+ 보안 요소와 오픈소스 아키텍처를 기반으로,\nLUKKEY는 하드웨어와 소프트웨어 보안을 모두 독립적으로 검증할 수 있게 합니다.\n\n키 생성, 저장, 서명은 기기 내부에서 보호되며,\n오픈소스 코드는 커뮤니티의 투명한 보안 검토를 가능하게 합니다.\n\n검증할 수 있는 보안. 당신에게 남는 통제권.",
    "lukkey.video.title": "보호를 위해 만들어지고, 오래도록 설계되다.",
    "lukkey.video.description":
      "스위스식 정밀함과 보안 집착으로 완성된 LUKKEY는 완전한 통제를 원하는 사람들을 위한 콜드 월렛입니다.",
    "lukkey.values.privacy.title": "프라이버시",
    "lukkey.values.privacy.description":
      "키는 절대 기기를 떠나지 않습니다. 에어갭 서명은 민감한 작업을 완전히 오프라인으로 유지합니다.",
    "lukkey.values.inclusive.title": "포용적 디자인",
    "lukkey.values.inclusive.description":
      "사람 중심의 디자인으로 초보자에게는 명확하고 전문가에게는 효율적입니다.",
    "lukkey.values.secure.title": "보안",
    "lukkey.values.secure.description":
      "변조, 추출, 스푸핑에 대응하는 다층 하드웨어 기반 보호.",
    "lukkey.values.environment.title": "지속 가능성",
    "lukkey.values.environment.description":
      "내구성 있는 소재, 수리 친화적 구조, 교체 폐기물 감소를 통해 장기 사용을 지향합니다.",
    "lukkey.contact.title": "계속 소식을 받아보세요",
    "lukkey.contact.announcements": "공지 사항은 블로그에서 확인할 수 있습니다.",
    "lukkey.contact.pressLabel": "언론 문의:",
  },
  ru: {
    "lukkey.hero.subtitle": "Ваши активы — под вашим контролем.",
    "lukkey.hero.reserveSubtitle":
      "Забронируйте за 1 $. Получите цену Early Bird, приоритетный доступ и бесплатную NFC-карту для резервного копирования.",
    "lukkey.hero.heroCtaLabel": "Забронировать за 1 $",
    "lukkey.hero.heroCtaNote": "Полный возврат средств. Без обязательства покупки.",
    "lukkey.hero.buy": "Забронировать Lukkey за 1 $",
    "lukkey.hero.buyWithPrice": "Забронировать Lukkey за {{price}}",
    "lukkey.hero.swissBadgeLabel": "Швейцарский бренд",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Офлайн cold wallet для криптовалют с доступом по отпечатку",
    "lukkey.seo.description": "LUKKEY — швейцарский аппаратный кошелек для безопасного self-custody с офлайн-защитой приватных ключей, чипом безопасности EAL6+, доступом по отпечатку пальца, NFC-резервным копированием и поддержкой нескольких независимых кошельков.",
    "lukkey.seoIntent.eyebrow": "Гид по аппаратным кошелькам",
    "lukkey.seoIntent.title": "Почему пользователи ищут cold wallet вроде LUKKEY",
    "lukkey.seoIntent.intro": "Аппаратный кошелек должен не только выглядеть безопасно. Он должен держать приватные ключи офлайн, делать восстановление практичным и давать долгосрочным держателям более понятный путь self-custody.",
    "lukkey.seoIntent.cards.offline.title": "Офлайн-хранение приватных ключей",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY разработан как аппаратный кошелек, который держит приватные ключи офлайн, а не оставляет их открытыми в браузере, на бирже или в постоянно подключенном приложении.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Для долгосрочных держателей и серьезных криптопользователей cold wallet снижает удаленную поверхность атаки и дает больший контроль, чем хранение активов только на биржах или в программных кошельках.",
    "lukkey.seoIntent.cards.recovery.title": "Доступ по отпечатку и NFC-резервное копирование",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY сочетает безопасность на уровне hardware с практичными инструментами восстановления, включая доступ по отпечатку для повседневного использования и NFC-резервное копирование для более безопасного self-custody.",
    "lukkey.seoIntent.cards.fit.title": "Создан для безопасного self-custody",
    "lukkey.seoIntent.cards.fit.body": "Если вы ищете аппаратный кошелек для Bitcoin, Ethereum, USDT и управления несколькими криптоаккаунтами, LUKKEY спроектирован вокруг приватности, разделения и долгосрочного контроля.",
    "lukkey.highlights.title": "Ознакомьтесь с ключевыми преимуществами Lukkey.",
    "lukkey.physical.title": "Безопасность, встроенная в кремний.",
    "lukkey.physical.subtitle":
      "Аппаратная архитектура безопасности на базе нескольких защищенных элементов, основанная на корне доверия EAL6+ и усиленная схемотехникой и конструкцией с защитой от вскрытия.",
    "lukkey.design.title": "Дизайн — это не украшение, а доверие",
    "lukkey.design.description":
      "Промышленный дизайн уровня iF и Red Dot с акцентом на скошенные грани и тонкие отражения стекла.",
    "lukkey.reliability.title": "Водозащита IP68\nПылезащита IP6X",
    "lukkey.reliability.description":
      "Водозащита IP68 и пылезащита IP6X, созданные для блокировки воды и мелких частиц в суровых условиях.",
    "lukkey.reliability.canvasLine1": "Водозащита IP68",
    "lukkey.reliability.canvasLine2": "Пылезащита IP6X",
    "lukkey.system.title": "Безопасный режим",
    "lukkey.system.description":
      "Незаметный защитный слой для чувствительных ситуаций.\n\nSafenotes маскирует интерфейс кошелька под страницу заметок,\nпри этом видимым остается только активный аккаунт.\nЧувствительные операции, например удаление одного аккаунта, ограничены.",
    "lukkey.system.multiAccountTitle":
      "Поддержка 3 независимых seed-фраз",
    "lukkey.system.multiAccountDescription":
      "Создавайте до трех полностью независимых кошельков, каждый со своей seed-фразой. Разделяйте активы, стратегии или личности, сохраняя полный контроль над цифровыми активами.",
    "lukkey.daily.title": "Разблокировка по отпечатку",
    "lukkey.daily.description":
      "Разблокируйте кошелек мгновенно с помощью отпечатка пальца.\n\nБыстро, бесшовно и с проверкой прямо на устройстве.",
    "lukkey.capability.title": "Поддержка NFT",
    "lukkey.capability.description":
      "Темное пространство для демонстрации активов с карточками в стеклянной эстетике и низкой насыщенностью, подчеркивающее владение и контроль.",
    "lukkey.backup.title": "NFC-карта резервного копирования",
    "lukkey.backup.description":
      "NFC-карта резервного копирования с защищенным элементом EAL6+.\nПросто приложите устройство, чтобы безопасно сохранить или импортировать seed-фразы.",
    "lukkey.trust.title": "Открытая и проверяемая безопасность",
    "lukkey.trust.description":
      "Основанный на защищенном элементе EAL6+ и архитектуре с открытым исходным кодом,\nLUKKEY позволяет независимо проверять безопасность как аппаратной, так и программной части.\n\nГенерация, хранение и подпись ключей остаются защищенными внутри устройства,\nа открытый код дает сообществу возможность прозрачного аудита безопасности.\n\nБезопасность, которую можно проверить. Контроль, который остается вашим.",
    "lukkey.video.title": "Создан для защиты. Спроектирован надолго.",
    "lukkey.video.description":
      "Швейцарская точность и одержимость безопасностью. LUKKEY — холодный кошелек для тех, кто требует полного контроля.",
    "lukkey.values.privacy.title": "Конфиденциальность",
    "lukkey.values.privacy.description":
      "Ваши ключи никогда не покидают устройство. Air-gapped-подпись удерживает чувствительные операции полностью офлайн.",
    "lukkey.values.inclusive.title": "Инклюзивный дизайн",
    "lukkey.values.inclusive.description":
      "Человекоцентричный дизайн, понятный новичкам и эффективный для экспертов.",
    "lukkey.values.secure.title": "Безопасность",
    "lukkey.values.secure.description":
      "Аппаратная защита с несколькими уровнями против вскрытия, извлечения и подмены.",
    "lukkey.values.environment.title": "Экологичность",
    "lukkey.values.environment.description":
      "Создан для долгого использования: прочные материалы, ремонтопригодная конструкция и меньше отходов от замены.",
    "lukkey.contact.title": "Оставайтесь на связи",
    "lukkey.contact.announcements": "Объявления доступны в нашем блоге.",
    "lukkey.contact.pressLabel": "Контакт для прессы:",
  },
  uk: {
    "lukkey.hero.subtitle": "Ваші активи — під вашим контролем.",
    "lukkey.hero.reserveSubtitle":
      "Забронюйте за 1 $. Отримайте ціну Early Bird, пріоритетний доступ і безкоштовну NFC-картку резервного копіювання.",
    "lukkey.hero.heroCtaLabel": "Забронювати за 1 $",
    "lukkey.hero.heroCtaNote": "Повне відшкодування. Без зобов’язання купівлі.",
    "lukkey.hero.buy": "Забронювати Lukkey за 1 $",
    "lukkey.hero.buyWithPrice": "Забронювати Lukkey за {{price}}",
    "lukkey.hero.swissBadgeLabel": "Швейцарський бренд",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Офлайн cold wallet для криптовалют із доступом за відбитком",
    "lukkey.seo.description": "LUKKEY — швейцарський апаратний гаманець для безпечного self-custody з офлайн-захистом приватних ключів, чипом безпеки EAL6+, доступом за відбитком пальця, NFC-резервним копіюванням і підтримкою кількох незалежних гаманців.",
    "lukkey.seoIntent.eyebrow": "Гід по апаратних гаманцях",
    "lukkey.seoIntent.title": "Чому користувачі шукають cold wallet на кшталт LUKKEY",
    "lukkey.seoIntent.intro": "Апаратний гаманець має не лише виглядати безпечним. Він повинен зберігати приватні ключі офлайн, робити відновлення практичним і давати довгостроковим власникам зрозуміліший шлях self-custody.",
    "lukkey.seoIntent.cards.offline.title": "Офлайн-зберігання приватних ключів",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY створений як апаратний гаманець, що зберігає приватні ключі офлайн, а не залишає їх відкритими в браузері, на біржі чи в постійно підключеному застосунку.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Для довгострокових власників і користувачів, які серйозно ставляться до безпеки, cold wallet зменшує віддалену поверхню атаки і дає пряміший контроль, ніж зберігання активів лише на біржах або в софт-гаманцях.",
    "lukkey.seoIntent.cards.recovery.title": "Доступ за відбитком і NFC-резервне копіювання",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY поєднує апаратний рівень безпеки з практичними інструментами відновлення, включно з доступом за відбитком для щоденного користування та NFC-резервним копіюванням для безпечнішого self-custody.",
    "lukkey.seoIntent.cards.fit.title": "Створений для безпечного self-custody",
    "lukkey.seoIntent.cards.fit.body": "Якщо ви шукаєте апаратний гаманець для Bitcoin, Ethereum, USDT і керування кількома криптоакаунтами, LUKKEY спроєктований навколо приватності, розділення та довгострокового контролю.",
    "lukkey.highlights.title": "Ознайомтеся з ключовими перевагами Lukkey.",
    "lukkey.physical.title": "Безпека, вбудована в кремній.",
    "lukkey.physical.subtitle":
      "Апаратна архітектура безпеки на базі кількох захищених елементів, закріплена коренем довіри EAL6+ та посилена схемотехнікою й конструкцією із захистом від втручання.",
    "lukkey.design.title": "Дизайн — це не прикраса, а довіра",
    "lukkey.design.description":
      "Промисловий дизайн рівня iF і Red Dot, що підкреслює скошені краї та делікатні відблиски скла.",
    "lukkey.reliability.title": "IP68 водозахист\nIP6X пилозахист",
    "lukkey.reliability.description":
      "Захист від води за стандартом IP68 і захист від пилу за стандартом IP6X, створені для блокування води та дрібних частинок у суворих умовах.",
    "lukkey.reliability.canvasLine1": "IP68 водозахист",
    "lukkey.reliability.canvasLine2": "IP6X пилозахист",
    "lukkey.system.title": "Безпечний режим",
    "lukkey.system.description":
      "Непомітний шар захисту для чутливих ситуацій.\n\nSafenotes маскує інтерфейс гаманця під сторінку нотаток,\nпри цьому видимим залишається лише активний акаунт.\nЧутливі операції, як-от видалення окремого акаунта, обмежені.",
    "lukkey.system.multiAccountTitle":
      "Підтримка 3 незалежних фраз відновлення",
    "lukkey.system.multiAccountDescription":
      "Створюйте до трьох повністю незалежних гаманців, кожен із власною фразою відновлення. Розділяйте активи, стратегії або особистості, зберігаючи повний контроль над цифровими активами.",
    "lukkey.daily.title": "Розблокування відбитком",
    "lukkey.daily.description":
      "Розблокуйте гаманець миттєво за допомогою автентифікації відбитком пальця.\n\nШвидко, плавно й перевірено безпосередньо на пристрої.",
    "lukkey.capability.title": "Підтримка NFT",
    "lukkey.capability.description":
      "Темний простір для демонстрації активів із картками зі скляним ефектом і низькою насиченістю, що підкреслює володіння та контроль.",
    "lukkey.backup.title": "NFC-картка резервного копіювання",
    "lukkey.backup.description":
      "NFC-картка резервного копіювання із захищеним елементом EAL6+.\nПросто торкніться пристрою, щоб безпечно зберегти або імпортувати фрази відновлення.",
    "lukkey.trust.title": "Відкрита та перевірювана безпека",
    "lukkey.trust.description":
      "Побудований на захищеному елементі EAL6+ та відкритій архітектурі,\nLUKKEY дозволяє незалежно перевіряти безпеку як апаратного, так і програмного рівня.\n\nГенерація, зберігання та підпис ключів залишаються захищеними всередині пристрою,\nа відкритий код дає спільноті можливість прозорої перевірки безпеки.\n\nБезпека, яку можна перевірити. Контроль, який залишається вашим.",
    "lukkey.video.title": "Створений для захисту. Спроєктований надовго.",
    "lukkey.video.description":
      "Швейцарська точність і одержимість безпекою. LUKKEY — це холодний гаманець для тих, хто вимагає повного контролю.",
    "lukkey.values.privacy.title": "Приватність",
    "lukkey.values.privacy.description":
      "Ваші ключі ніколи не залишають пристрій. Air-gapped-підпис утримує чутливі операції повністю офлайн.",
    "lukkey.values.inclusive.title": "Інклюзивний дизайн",
    "lukkey.values.inclusive.description":
      "Людиноцентричний дизайн, зрозумілий новачкам і ефективний для досвідчених користувачів.",
    "lukkey.values.secure.title": "Безпека",
    "lukkey.values.secure.description":
      "Апаратний захист із кількома шарами безпеки від втручання, вилучення та підміни.",
    "lukkey.values.environment.title": "Стійкість",
    "lukkey.values.environment.description":
      "Створений для тривалого використання завдяки міцним матеріалам, придатній до ремонту конструкції та меншій кількості відходів від заміни.",
    "lukkey.contact.title": "Залишайтеся на зв’язку",
    "lukkey.contact.announcements": "Оголошення можна знайти в нашому блозі.",
    "lukkey.contact.pressLabel": "Контакт для преси:",
  },
  id: {
    "lukkey.hero.subtitle": "Aset Anda, kendali Anda.",
    "lukkey.hero.reserveSubtitle":
      "Reservasi dengan US$1. Dapatkan harga Early Bird, akses prioritas, dan kartu cadangan NFC gratis.",
    "lukkey.hero.heroCtaLabel": "Reservasi dengan US$1",
    "lukkey.hero.heroCtaNote": "Dapat dikembalikan sepenuhnya. Tanpa komitmen pembelian.",
    "lukkey.hero.buy": "Reservasi Lukkey dengan US$1",
    "lukkey.hero.buyWithPrice": "Reservasi Lukkey dengan {{price}}",
    "lukkey.hero.swissBadgeLabel": "Merek Swiss",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Cold wallet crypto offline dengan akses sidik jari",
    "lukkey.seo.description": "LUKKEY adalah dompet hardware Swiss untuk self-custody yang aman, dengan perlindungan offline untuk private key, chip aman EAL6+, akses sidik jari, backup NFC, dan dukungan untuk beberapa wallet independen.",
    "lukkey.seoIntent.eyebrow": "Panduan dompet hardware",
    "lukkey.seoIntent.title": "Mengapa orang mencari cold wallet seperti LUKKEY",
    "lukkey.seoIntent.intro": "Dompet hardware harus melakukan lebih dari sekadar terlihat aman. Ia harus menjaga private key tetap offline, membuat pemulihan lebih praktis, dan memberi pemegang jangka panjang alur self-custody yang lebih jelas.",
    "lukkey.seoIntent.cards.offline.title": "Penyimpanan private key secara offline",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY dirancang sebagai dompet hardware yang menjaga private key tetap offline, bukan membiarkannya terekspos di browser, exchange, atau aplikasi yang selalu terhubung.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Bagi pemegang jangka panjang dan pengguna crypto yang serius, cold wallet mengurangi permukaan serangan jarak jauh dan memberi kontrol lebih langsung dibanding menyimpan aset hanya di exchange atau software wallet.",
    "lukkey.seoIntent.cards.recovery.title": "Akses sidik jari dan backup NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY menggabungkan keamanan berbasis hardware dengan alat pemulihan yang praktis, termasuk akses sidik jari untuk penggunaan harian dan alur backup NFC untuk self-custody yang lebih aman.",
    "lukkey.seoIntent.cards.fit.title": "Dibuat untuk self-custody yang aman",
    "lukkey.seoIntent.cards.fit.body": "Jika Anda mencari dompet hardware untuk Bitcoin, Ethereum, USDT, dan pengelolaan multi-akun crypto, LUKKEY dirancang dengan fokus pada privasi, pemisahan, dan kontrol jangka panjang.",
    "lukkey.highlights.title": "Lihat sorotan utama Lukkey.",
    "lukkey.physical.title": "Keamanan, tertanam di silikon.",
    "lukkey.physical.subtitle":
      "Arsitektur keamanan perangkat keras yang dibangun di atas beberapa elemen aman, berlandaskan root of trust EAL6+ dan diperkuat dengan desain sirkuit serta struktur tahan manipulasi.",
    "lukkey.design.title": "Desain bukan dekorasi, melainkan kredibilitas",
    "lukkey.design.description":
      "Desain industri dengan tingkat pengerjaan setara iF dan Red Dot, menonjolkan tepi chamfer serta pantulan kaca yang halus.",
    "lukkey.reliability.title": "Tahan air IP68\nTahan debu IP6X",
    "lukkey.reliability.description":
      "Perlindungan tahan air IP68 dan tahan debu IP6X, dirancang untuk menahan masuknya air dan partikel halus di lingkungan berat.",
    "lukkey.reliability.canvasLine1": "Tahan air IP68",
    "lukkey.reliability.canvasLine2": "Tahan debu IP6X",
    "lukkey.system.title": "Mode aman",
    "lukkey.system.description":
      "Lapisan perlindungan yang tersembunyi untuk situasi sensitif.\n\nSafenotes menyamarkan antarmuka wallet seperti halaman catatan,\nsementara hanya akun aktif yang tetap terlihat.\nOperasi sensitif seperti penghapusan satu akun juga dibatasi.",
    "lukkey.system.multiAccountTitle":
      "Mendukung 3 frasa pemulihan independen",
    "lukkey.system.multiAccountDescription":
      "Buat hingga tiga wallet yang sepenuhnya independen, masing-masing diamankan oleh frasa pemulihannya sendiri. Pisahkan aset, strategi, atau identitas sambil tetap memegang kendali penuh atas aset digital Anda.",
    "lukkey.daily.title": "Buka kunci sidik jari",
    "lukkey.daily.description":
      "Buka wallet Anda seketika dengan autentikasi sidik jari.\n\nCepat, mulus, dan diverifikasi langsung di perangkat.",
    "lukkey.capability.title": "Dukungan NFT",
    "lukkey.capability.description":
      "Ruang tampilan aset bernuansa gelap dengan kartu bergaya kaca dan saturasi rendah untuk menonjolkan kepemilikan dan kontrol.",
    "lukkey.backup.title": "Kartu cadangan NFC",
    "lukkey.backup.description":
      "Kartu cadangan NFC dengan elemen aman EAL6+.\nCukup tempelkan ke perangkat untuk mencadangkan atau mengimpor frasa pemulihan dengan aman.",
    "lukkey.trust.title": "Keamanan terbuka dan dapat diverifikasi",
    "lukkey.trust.description":
      "Dibangun di atas elemen aman EAL6+ dan arsitektur open-source,\nLUKKEY memungkinkan keamanan perangkat keras dan perangkat lunak diverifikasi secara independen.\n\nPembuatan, penyimpanan, dan penandatanganan kunci tetap terlindungi di dalam perangkat,\nsementara kode open-source memungkinkan tinjauan keamanan yang transparan oleh komunitas.\n\nKeamanan yang bisa Anda verifikasi. Kendali yang tetap menjadi milik Anda.",
    "lukkey.video.title": "Dibuat untuk melindungi. Dirancang untuk tahan lama.",
    "lukkey.video.description":
      "Dibuat dengan presisi Swiss dan berfokus pada keamanan, LUKKEY adalah cold wallet bagi mereka yang menuntut kendali penuh.",
    "lukkey.values.privacy.title": "Privasi",
    "lukkey.values.privacy.description":
      "Kunci Anda tidak pernah meninggalkan perangkat. Penandatanganan air-gapped menjaga operasi sensitif tetap sepenuhnya offline.",
    "lukkey.values.inclusive.title": "Desain inklusif",
    "lukkey.values.inclusive.description":
      "Desain yang berpusat pada manusia, jelas bagi pemula dan efisien bagi pengguna ahli.",
    "lukkey.values.secure.title": "Aman",
    "lukkey.values.secure.description":
      "Perlindungan berbasis perangkat keras dengan lapisan pengamanan terhadap manipulasi, ekstraksi, dan spoofing.",
    "lukkey.values.environment.title": "Keberlanjutan",
    "lukkey.values.environment.description":
      "Dibuat untuk penggunaan jangka panjang dengan material tahan lama, struktur yang mudah dirawat, dan limbah penggantian yang lebih sedikit.",
    "lukkey.contact.title": "Tetap terhubung",
    "lukkey.contact.announcements": "Pengumuman dapat ditemukan di blog kami.",
    "lukkey.contact.pressLabel": "Kontak pers:",
  },
  vi: {
    "lukkey.hero.subtitle": "Tài sản của bạn, quyền kiểm soát của bạn.",
    "lukkey.hero.reserveSubtitle":
      "Đặt trước với 1 USD. Nhận giá Early Bird, quyền ưu tiên truy cập và thẻ sao lưu NFC miễn phí.",
    "lukkey.hero.heroCtaLabel": "Đặt chỗ với 1 USD",
    "lukkey.hero.heroCtaNote": "Hoàn tiền toàn bộ. Không cam kết mua hàng.",
    "lukkey.hero.buy": "Đặt trước Lukkey với 1 USD",
    "lukkey.hero.buyWithPrice": "Đặt trước Lukkey với {{price}}",
    "lukkey.hero.swissBadgeLabel": "Thương hiệu Thụy Sĩ",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Ví lạnh crypto ngoại tuyến với truy cập vân tay",
    "lukkey.seo.description": "LUKKEY là ví phần cứng Thụy Sĩ dành cho self-custody an toàn, với bảo vệ khóa riêng ngoại tuyến, chip bảo mật EAL6+, truy cập bằng vân tay, sao lưu NFC và hỗ trợ nhiều ví độc lập.",
    "lukkey.seoIntent.eyebrow": "Hướng dẫn ví phần cứng",
    "lukkey.seoIntent.title": "Vì sao người dùng tìm kiếm một cold wallet như LUKKEY",
    "lukkey.seoIntent.intro": "Một ví phần cứng không chỉ cần trông an toàn. Nó phải giữ khóa riêng ở trạng thái ngoại tuyến, làm cho việc khôi phục trở nên thực tế hơn và mang lại quy trình self-custody rõ ràng hơn cho người nắm giữ dài hạn.",
    "lukkey.seoIntent.cards.offline.title": "Lưu trữ khóa riêng ngoại tuyến",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY được thiết kế như một ví phần cứng giữ khóa riêng ở trạng thái ngoại tuyến thay vì để chúng lộ ra trong trình duyệt, trên sàn giao dịch hoặc trong ứng dụng luôn kết nối.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Với người nắm giữ dài hạn và người dùng crypto nghiêm túc, cold wallet giúp giảm bề mặt tấn công từ xa và mang lại quyền kiểm soát trực tiếp hơn so với việc chỉ lưu tài sản trên sàn hoặc ví phần mềm.",
    "lukkey.seoIntent.cards.recovery.title": "Truy cập bằng vân tay và sao lưu NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY kết hợp bảo mật ưu tiên phần cứng với các công cụ khôi phục thực tế, bao gồm truy cập bằng vân tay cho sử dụng hằng ngày và quy trình sao lưu NFC cho self-custody an toàn hơn.",
    "lukkey.seoIntent.cards.fit.title": "Được xây dựng cho self-custody an toàn",
    "lukkey.seoIntent.cards.fit.body": "Nếu bạn đang tìm một ví phần cứng cho Bitcoin, Ethereum, USDT và quản lý nhiều tài khoản crypto, LUKKEY được thiết kế xoay quanh quyền riêng tư, sự tách biệt và khả năng kiểm soát lâu dài.",
    "lukkey.highlights.title": "Khám phá những điểm nổi bật của Lukkey.",
    "lukkey.physical.title": "Bảo mật, được xây vào silicon.",
    "lukkey.physical.subtitle":
      "Một kiến trúc bảo mật phần cứng được xây dựng trên nhiều phần tử bảo mật, neo bằng gốc tin cậy EAL6+ và được gia cố bằng mạch và cấu trúc chống can thiệp.",
    "lukkey.design.title": "Thiết kế không phải là trang trí, mà là độ tin cậy",
    "lukkey.design.description":
      "Thiết kế công nghiệp với độ hoàn thiện ở mức iF và Red Dot, nhấn mạnh các cạnh vát và phản chiếu kính tinh tế.",
    "lukkey.reliability.title": "Chống nước IP68\nChống bụi IP6X",
    "lukkey.reliability.description":
      "Khả năng chống nước IP68 và chống bụi IP6X, được thiết kế để ngăn nước và các hạt mịn xâm nhập trong môi trường khắc nghiệt.",
    "lukkey.reliability.canvasLine1": "Chống nước IP68",
    "lukkey.reliability.canvasLine2": "Chống bụi IP6X",
    "lukkey.system.title": "Chế độ an toàn",
    "lukkey.system.description":
      "Một lớp bảo vệ kín đáo cho các tình huống nhạy cảm.\n\nSafenotes ngụy trang giao diện ví thành một trang ghi chú,\ntrong khi chỉ tài khoản đang hoạt động vẫn hiển thị.\nCác thao tác nhạy cảm như xóa một tài khoản cũng bị hạn chế.",
    "lukkey.system.multiAccountTitle":
      "Hỗ trợ 3 cụm từ khôi phục độc lập",
    "lukkey.system.multiAccountDescription":
      "Tạo tối đa ba ví hoàn toàn độc lập, mỗi ví được bảo vệ bằng cụm từ khôi phục riêng. Tách biệt tài sản, chiến lược hoặc danh tính trong khi vẫn giữ toàn quyền kiểm soát tài sản số của bạn.",
    "lukkey.daily.title": "Mở khóa bằng vân tay",
    "lukkey.daily.description":
      "Mở khóa ví ngay lập tức bằng xác thực vân tay.\n\nNhanh, mượt và được xác minh trực tiếp trên thiết bị.",
    "lukkey.capability.title": "Hỗ trợ NFT",
    "lukkey.capability.description":
      "Một không gian trưng bày tài sản nền tối với các thẻ hiệu ứng kính và độ bão hòa thấp để nhấn mạnh quyền sở hữu và khả năng kiểm soát.",
    "lukkey.backup.title": "Thẻ sao lưu NFC",
    "lukkey.backup.description":
      "Một thẻ sao lưu NFC với phần tử bảo mật EAL6+.\nChỉ cần chạm vào thiết bị để sao lưu hoặc nhập cụm từ khôi phục một cách an toàn.",
    "lukkey.trust.title": "Bảo mật mở và có thể kiểm chứng",
    "lukkey.trust.description":
      "Được xây dựng trên phần tử bảo mật EAL6+ và kiến trúc mã nguồn mở,\nLUKKEY cho phép cả bảo mật phần cứng và phần mềm được kiểm chứng độc lập.\n\nViệc tạo khóa, lưu trữ và ký vẫn được bảo vệ bên trong thiết bị,\ntrong khi mã nguồn mở cho phép cộng đồng đánh giá bảo mật một cách minh bạch.\n\nBảo mật có thể kiểm chứng. Quyền kiểm soát vẫn thuộc về bạn.",
    "lukkey.video.title": "Sinh ra để bảo vệ. Thiết kế để bền bỉ.",
    "lukkey.video.description":
      "Được chế tác theo tiêu chuẩn Thụy Sĩ và ám ảnh với bảo mật, LUKKEY là ví lạnh dành cho những người đòi hỏi sự kiểm soát tuyệt đối.",
    "lukkey.values.privacy.title": "Riêng tư",
    "lukkey.values.privacy.description":
      "Khóa của bạn không bao giờ rời khỏi thiết bị. Ký air-gapped giữ các thao tác nhạy cảm hoàn toàn ngoại tuyến.",
    "lukkey.values.inclusive.title": "Thiết kế bao trùm",
    "lukkey.values.inclusive.description":
      "Thiết kế lấy con người làm trung tâm, rõ ràng cho người mới và hiệu quả cho người dùng chuyên sâu.",
    "lukkey.values.secure.title": "An toàn",
    "lukkey.values.secure.description":
      "Bảo vệ dựa trên phần cứng với nhiều lớp phòng vệ trước can thiệp, trích xuất và giả mạo.",
    "lukkey.values.environment.title": "Bền vững",
    "lukkey.values.environment.description":
      "Được xây dựng cho sử dụng lâu dài với vật liệu bền, cấu trúc dễ bảo trì và ít lãng phí do thay thế.",
    "lukkey.contact.title": "Giữ liên lạc",
    "lukkey.contact.announcements": "Các thông báo có thể được tìm thấy trên blog của chúng tôi.",
    "lukkey.contact.pressLabel": "Liên hệ báo chí:",
  },
  th: {
    "lukkey.hero.subtitle": "สินทรัพย์ของคุณ การควบคุมของคุณ",
    "lukkey.hero.reserveSubtitle":
      "จองด้วย 1 ดอลลาร์ เพื่อรับสิทธิ์ราคา Early Bird สิทธิ์เข้าถึงก่อนใคร และบัตรสำรอง NFC ฟรี",
    "lukkey.hero.heroCtaLabel": "จองด้วย 1 ดอลลาร์",
    "lukkey.hero.heroCtaNote": "ขอคืนเงินได้เต็มจำนวน ไม่มีข้อผูกมัดในการซื้อ",
    "lukkey.hero.buy": "จอง Lukkey ด้วย 1 ดอลลาร์",
    "lukkey.hero.buyWithPrice": "จอง Lukkey ด้วย {{price}}",
    "lukkey.hero.swissBadgeLabel": "แบรนด์สวิส",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | กระเป๋า cold wallet แบบออฟไลน์พร้อมการเข้าถึงด้วยลายนิ้วมือ",
    "lukkey.seo.description": "LUKKEY คือฮาร์ดแวร์วอลเล็ตจากสวิตเซอร์แลนด์สำหรับ self-custody ที่ปลอดภัย พร้อมการปกป้อง private key แบบออฟไลน์ ชิปความปลอดภัย EAL6+ การเข้าถึงด้วยลายนิ้วมือ การสำรองข้อมูลด้วย NFC และการรองรับหลายกระเป๋าแบบอิสระ",
    "lukkey.seoIntent.eyebrow": "คู่มือฮาร์ดแวร์วอลเล็ต",
    "lukkey.seoIntent.title": "ทำไมผู้ใช้จึงค้นหา cold wallet อย่าง LUKKEY",
    "lukkey.seoIntent.intro": "ฮาร์ดแวร์วอลเล็ตควรทำได้มากกว่าแค่ดูปลอดภัย มันควรเก็บ private key แบบออฟไลน์ ทำให้การกู้คืนใช้งานได้จริง และมอบเส้นทาง self-custody ที่ชัดเจนขึ้นสำหรับผู้ถือระยะยาว",
    "lukkey.seoIntent.cards.offline.title": "การเก็บ private key แบบออฟไลน์",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY ถูกออกแบบให้เป็นฮาร์ดแวร์วอลเล็ตที่เก็บ private key แบบออฟไลน์ แทนที่จะปล่อยให้คีย์ถูกเปิดเผยในเบราว์เซอร์ บน exchange หรือในแอปที่เชื่อมต่ออยู่ตลอดเวลา",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "สำหรับผู้ถือระยะยาวและผู้ใช้คริปโตที่จริงจัง cold wallet ช่วยลดพื้นผิวการโจมตีจากระยะไกล และให้การควบคุมที่ตรงกว่าเมื่อเทียบกับการเก็บสินทรัพย์ไว้แค่บน exchange หรือ software wallet",
    "lukkey.seoIntent.cards.recovery.title": "การเข้าถึงด้วยลายนิ้วมือและการสำรองข้อมูล NFC",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY ผสานความปลอดภัยแบบ hardware-first เข้ากับเครื่องมือกู้คืนที่ใช้งานได้จริง รวมถึงการเข้าถึงด้วยลายนิ้วมือสำหรับการใช้งานประจำวัน และกระบวนการสำรองข้อมูล NFC เพื่อ self-custody ที่ปลอดภัยยิ่งขึ้น",
    "lukkey.seoIntent.cards.fit.title": "สร้างมาเพื่อ self-custody ที่ปลอดภัย",
    "lukkey.seoIntent.cards.fit.body": "หากคุณกำลังมองหาฮาร์ดแวร์วอลเล็ตสำหรับ Bitcoin, Ethereum, USDT และการจัดการหลายบัญชีคริปโต LUKKEY ถูกออกแบบโดยเน้นความเป็นส่วนตัว การแยกทรัพย์สิน และการควบคุมระยะยาว",
    "lukkey.highlights.title": "ดูจุดเด่นสำคัญของ Lukkey",
    "lukkey.physical.title": "ความปลอดภัยที่ฝังอยู่ในซิลิคอน",
    "lukkey.physical.subtitle":
      "สถาปัตยกรรมความปลอดภัยฮาร์ดแวร์ที่สร้างบนองค์ประกอบความปลอดภัยหลายชั้น ยึดด้วยรากฐานความเชื่อถือ EAL6+ และเสริมด้วยวงจรและโครงสร้างป้องกันการงัดแงะ",
    "lukkey.design.title": "ดีไซน์ไม่ใช่การตกแต่ง แต่คือความน่าเชื่อถือ",
    "lukkey.design.description":
      "งานออกแบบอุตสาหกรรมระดับ iF และ Red Dot ที่เน้นขอบเฉียงและเงาสะท้อนกระจกอย่างละเอียดอ่อน",
    "lukkey.reliability.title": "กันน้ำระดับ IP68\nกันฝุ่นระดับ IP6X",
    "lukkey.reliability.description":
      "การป้องกันน้ำระดับ IP68 และการป้องกันฝุ่นระดับ IP6X ออกแบบมาเพื่อกันน้ำและอนุภาคละเอียดในสภาพแวดล้อมที่โหดร้าย",
    "lukkey.reliability.canvasLine1": "กันน้ำระดับ IP68",
    "lukkey.reliability.canvasLine2": "กันฝุ่นระดับ IP6X",
    "lukkey.system.title": "โหมดปลอดภัย",
    "lukkey.system.description":
      "ชั้นการป้องกันแบบแนบเนียนสำหรับสถานการณ์ที่อ่อนไหว\n\nSafenotes ปลอมอินเทอร์เฟซกระเป๋าให้ดูเหมือนหน้าจดบันทึก\nขณะที่แสดงเฉพาะบัญชีที่กำลังใช้งานเท่านั้น\nการทำงานที่อ่อนไหว เช่น การลบบัญชีเดี่ยว จะถูกจำกัดไว้",
    "lukkey.system.multiAccountTitle": "รองรับวลีการกู้คืนอิสระ 3 ชุด",
    "lukkey.system.multiAccountDescription":
      "สร้างกระเป๋าได้สูงสุดสามใบที่แยกจากกันอย่างสมบูรณ์ แต่ละใบมีวลีการกู้คืนของตัวเอง แยกสินทรัพย์ กลยุทธ์ หรืออัตลักษณ์ได้ โดยยังคงควบคุมสินทรัพย์ดิจิทัลของคุณได้อย่างเต็มที่",
    "lukkey.daily.title": "ปลดล็อกด้วยลายนิ้วมือ",
    "lukkey.daily.description":
      "ปลดล็อกกระเป๋าของคุณได้ทันทีด้วยการยืนยันลายนิ้วมือ\n\nรวดเร็ว ลื่นไหล และตรวจสอบโดยตรงบนอุปกรณ์",
    "lukkey.capability.title": "รองรับ NFT",
    "lukkey.capability.description":
      "พื้นที่จัดแสดงสินทรัพย์โทนมืดพร้อมการ์ดพื้นผิวกระจกและสีอิ่มตัวต่ำ เพื่อเน้นความเป็นเจ้าของและการควบคุม",
    "lukkey.backup.title": "บัตรสำรอง NFC",
    "lukkey.backup.description":
      "บัตรสำรอง NFC พร้อมชิปความปลอดภัย EAL6+\nเพียงแตะอุปกรณ์เพื่อสำรองหรือกู้คืนวลีการกู้คืนอย่างปลอดภัย",
    "lukkey.trust.title": "ความปลอดภัยแบบเปิดและตรวจสอบได้",
    "lukkey.trust.description":
      "สร้างบนชิปความปลอดภัย EAL6+ และสถาปัตยกรรมโอเพ่นซอร์ส\nLUKKEY ทำให้ทั้งความปลอดภัยของฮาร์ดแวร์และซอฟต์แวร์สามารถตรวจสอบได้อย่างอิสระ\n\nการสร้างคีย์ การเก็บรักษา และการลงนามยังคงได้รับการปกป้องภายในอุปกรณ์\nขณะที่โค้ดโอเพ่นซอร์สเปิดให้ชุมชนตรวจสอบความปลอดภัยได้อย่างโปร่งใส\n\nความปลอดภัยที่คุณตรวจสอบได้ การควบคุมที่ยังคงเป็นของคุณ",
    "lukkey.video.title": "สร้างมาเพื่อปกป้อง ออกแบบมาเพื่อความทนทาน",
    "lukkey.video.description":
      "สร้างด้วยความประณีตแบบสวิสและมุ่งมั่นเรื่องความปลอดภัย LUKKEY คือ cold wallet สำหรับผู้ที่ต้องการการควบคุมอย่างสมบูรณ์",
    "lukkey.values.privacy.title": "ความเป็นส่วนตัว",
    "lukkey.values.privacy.description":
      "คีย์ของคุณไม่เคยออกจากอุปกรณ์ การลงนามแบบ air-gapped ทำให้การทำงานที่อ่อนไหวอยู่แบบออฟไลน์อย่างสมบูรณ์",
    "lukkey.values.inclusive.title": "การออกแบบที่ครอบคลุม",
    "lukkey.values.inclusive.description":
      "การออกแบบที่ยึดผู้ใช้เป็นศูนย์กลาง ชัดเจนสำหรับมือใหม่และมีประสิทธิภาพสำหรับผู้ใช้ระดับสูง",
    "lukkey.values.secure.title": "ปลอดภัย",
    "lukkey.values.secure.description":
      "การปกป้องระดับฮาร์ดแวร์พร้อมหลายชั้นความปลอดภัยต่อการงัดแงะ การดึงข้อมูล และการปลอมแปลง",
    "lukkey.values.environment.title": "ยั่งยืน",
    "lukkey.values.environment.description":
      "สร้างเพื่อการใช้งานระยะยาวด้วยวัสดุทนทาน โครงสร้างที่ซ่อมบำรุงได้ และลดของเสียจากการเปลี่ยนใหม่",
    "lukkey.contact.title": "ติดต่อกันไว้",
    "lukkey.contact.announcements": "สามารถดูประกาศต่าง ๆ ได้ในบล็อกของเรา",
    "lukkey.contact.pressLabel": "ติดต่อสื่อ:",
  },
  hi: {
    "lukkey.hero.subtitle": "आपकी संपत्ति, आपका नियंत्रण।",
    "lukkey.hero.reserveSubtitle":
      "$1 में आरक्षित करें। Early Bird कीमत, प्राथमिक एक्सेस और मुफ्त NFC बैकअप कार्ड पाएं।",
    "lukkey.hero.heroCtaLabel": "$1 में आरक्षित करें",
    "lukkey.hero.heroCtaNote": "पूरी तरह रिफंड योग्य। खरीद की कोई प्रतिबद्धता नहीं।",
    "lukkey.hero.buy": "$1 में Lukkey आरक्षित करें",
    "lukkey.hero.buyWithPrice": "{{price}} में Lukkey आरक्षित करें",
    "lukkey.hero.swissBadgeLabel": "स्विस ब्रांड",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | फिंगरप्रिंट एक्सेस वाला ऑफलाइन क्रिप्टो cold wallet",
    "lukkey.seo.description": "LUKKEY सुरक्षित self-custody के लिए बनाया गया एक Swiss hardware wallet है, जिसमें private key की offline सुरक्षा, EAL6+ secure chip, fingerprint access, NFC backup और कई स्वतंत्र wallets का समर्थन शामिल है।",
    "lukkey.seoIntent.eyebrow": "हार्डवेयर वॉलेट गाइड",
    "lukkey.seoIntent.title": "लोग LUKKEY जैसे cold wallet को क्यों खोजते हैं",
    "lukkey.seoIntent.intro": "एक hardware wallet को सिर्फ सुरक्षित दिखना ही नहीं चाहिए। उसे private key को offline रखना चाहिए, recovery को व्यावहारिक बनाना चाहिए, और long-term holders को self-custody का अधिक स्पष्ट workflow देना चाहिए।",
    "lukkey.seoIntent.cards.offline.title": "private key का offline storage",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY को ऐसे hardware wallet के रूप में डिजाइन किया गया है जो private key को browser, exchange या हमेशा connected app environment में expose होने के बजाय offline रखता है।",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "long-term holders और गंभीर crypto users के लिए cold wallet remote attack surface को कम करता है और assets को केवल exchange या software wallet में रखने की तुलना में अधिक सीधा control देता है।",
    "lukkey.seoIntent.cards.recovery.title": "fingerprint access और NFC backup",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY hardware-first security को practical recovery tools के साथ जोड़ता है, जिसमें daily use के लिए fingerprint access और अधिक सुरक्षित self-custody के लिए NFC backup flow शामिल है।",
    "lukkey.seoIntent.cards.fit.title": "सुरक्षित self-custody के लिए बनाया गया",
    "lukkey.seoIntent.cards.fit.body": "अगर आप Bitcoin, Ethereum, USDT और multi-account crypto management के लिए hardware wallet खोज रहे हैं, तो LUKKEY privacy, separation और long-term control को ध्यान में रखकर बनाया गया है।",
    "lukkey.highlights.title": "Lukkey की प्रमुख खूबियां देखें।",
    "lukkey.physical.title": "सुरक्षा, सिलिकॉन में निर्मित।",
    "lukkey.physical.subtitle":
      "एक हार्डवेयर सुरक्षा आर्किटेक्चर जो अनेक सुरक्षित तत्वों पर बना है, EAL6+ root of trust पर आधारित है, और छेड़छाड़-रोधी सर्किट व संरचनात्मक डिज़ाइन से मजबूत किया गया है।",
    "lukkey.design.title": "डिज़ाइन सजावट नहीं, विश्वसनीयता है",
    "lukkey.design.description":
      "iF और Red Dot स्तर की कारीगरी वाला औद्योगिक डिज़ाइन, जिसमें chamfered edges और हल्के ग्लास reflections पर जोर है।",
    "lukkey.reliability.title": "IP68 वॉटरप्रूफ\nIP6X डस्टप्रूफ",
    "lukkey.reliability.description":
      "IP68 वॉटरप्रूफ और IP6X डस्टप्रूफ सुरक्षा, कठिन वातावरण में पानी और महीन कणों की घुसपैठ रोकने के लिए बनाई गई है।",
    "lukkey.reliability.canvasLine1": "IP68 वॉटरप्रूफ",
    "lukkey.reliability.canvasLine2": "IP6X डस्टप्रूफ",
    "lukkey.system.title": "सेफ मोड",
    "lukkey.system.description":
      "संवेदनशील परिस्थितियों के लिए एक विवेकपूर्ण सुरक्षा परत।\n\nSafenotes वॉलेट इंटरफ़ेस को नोट्स-जैसे पेज के रूप में छिपा देता है,\nजबकि केवल सक्रिय खाता दिखाई देता है।\nएकल-खाता हटाने जैसी संवेदनशील कार्रवाइयों पर भी प्रतिबंध रहता है।",
    "lukkey.system.multiAccountTitle": "3 स्वतंत्र रिकवरी फ्रेज़ का समर्थन",
    "lukkey.system.multiAccountDescription":
      "तीन तक पूरी तरह स्वतंत्र वॉलेट बनाएं, जिनमें से प्रत्येक अपनी रिकवरी फ्रेज़ से सुरक्षित हो। अपनी डिजिटल संपत्तियों पर पूर्ण नियंत्रण रखते हुए संपत्तियां, रणनीतियां या पहचानें अलग रखें।",
    "lukkey.daily.title": "फिंगरप्रिंट अनलॉक",
    "lukkey.daily.description":
      "फिंगरप्रिंट प्रमाणीकरण से अपने वॉलेट को तुरंत अनलॉक करें।\n\nतेज़, सहज और सीधे डिवाइस पर सत्यापित।",
    "lukkey.capability.title": "NFT समर्थन",
    "lukkey.capability.description":
      "डार्क-स्पेस एसेट डिस्प्ले बे जिसमें ग्लासी कार्ड्स और लो सैचुरेशन के साथ स्वामित्व और नियंत्रण को उभारा गया है।",
    "lukkey.backup.title": "NFC बैकअप कार्ड",
    "lukkey.backup.description":
      "EAL6+ सुरक्षित तत्व वाला NFC बैकअप कार्ड।\nरिकवरी फ्रेज़ को सुरक्षित रूप से बैकअप या आयात करने के लिए बस डिवाइस टैप करें।",
    "lukkey.trust.title": "ओपन और सत्यापित होने योग्य सुरक्षा",
    "lukkey.trust.description":
      "EAL6+ सुरक्षित तत्व और ओपन-सोर्स आर्किटेक्चर पर निर्मित,\nLUKKEY हार्डवेयर और सॉफ़्टवेयर दोनों की सुरक्षा को स्वतंत्र रूप से सत्यापित करने देता है।\n\nकुंजी निर्माण, संग्रहण और हस्ताक्षर डिवाइस के भीतर सुरक्षित रहते हैं,\nजबकि ओपन-सोर्स कोड समुदाय द्वारा पारदर्शी सुरक्षा समीक्षा को सक्षम बनाता है।\n\nऐसी सुरक्षा जिसे आप सत्यापित कर सकते हैं। ऐसा नियंत्रण जो आपका ही रहता है।",
    "lukkey.video.title": "सुरक्षा के लिए निर्मित। लंबे समय के लिए डिज़ाइन किया गया।",
    "lukkey.video.description":
      "स्विस-स्तरीय कारीगरी और सुरक्षा के प्रति समर्पित, LUKKEY उन लोगों के लिए कोल्ड वॉलेट है जो पूर्ण नियंत्रण चाहते हैं।",
    "lukkey.values.privacy.title": "गोपनीयता",
    "lukkey.values.privacy.description":
      "आपकी keys कभी डिवाइस से बाहर नहीं जातीं। Air-gapped signing संवेदनशील कार्यों को पूरी तरह ऑफलाइन रखता है।",
    "lukkey.values.inclusive.title": "समावेशी डिज़ाइन",
    "lukkey.values.inclusive.description":
      "मानव-केंद्रित डिज़ाइन, शुरुआती लोगों के लिए स्पष्ट और विशेषज्ञों के लिए कुशल।",
    "lukkey.values.secure.title": "सुरक्षित",
    "lukkey.values.secure.description":
      "छेड़छाड़, extraction और spoofing के खिलाफ कई स्तरों वाली हार्डवेयर-आधारित सुरक्षा।",
    "lukkey.values.environment.title": "स्थायित्व",
    "lukkey.values.environment.description":
      "लंबे समय तक उपयोग के लिए टिकाऊ सामग्रियों, रखरखाव-अनुकूल संरचना और कम replacement waste के साथ निर्मित।",
    "lukkey.contact.title": "संपर्क में रहें",
    "lukkey.contact.announcements": "घोषणाएं हमारे ब्लॉग में मिल सकती हैं।",
    "lukkey.contact.pressLabel": "प्रेस संपर्क:",
  },
  ar: {
    "lukkey.hero.subtitle": "أصولك، وتحكّمك أنت.",
    "lukkey.hero.reserveSubtitle":
      "احجز مقابل 1 دولار. واحصل على سعر Early Bird، وأولوية الوصول، وبطاقة نسخ احتياطي NFC مجانية.",
    "lukkey.hero.heroCtaLabel": "احجز مقابل 1 دولار",
    "lukkey.hero.heroCtaNote": "قابل للاسترداد بالكامل. بدون التزام بالشراء.",
    "lukkey.hero.buy": "احجز Lukkey مقابل 1 دولار",
    "lukkey.hero.buyWithPrice": "احجز Lukkey مقابل {{price}}",
    "lukkey.hero.swissBadgeLabel": "علامة تجارية سويسرية",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | محفظة cold wallet مشفرة غير متصلة مع وصول بالبصمة",
    "lukkey.seo.description": "LUKKEY هي محفظة أجهزة سويسرية مصممة للحفظ الذاتي الآمن، مع حماية غير متصلة للمفاتيح الخاصة، وشريحة أمان EAL6+، ووصول ببصمة الإصبع، ونسخ احتياطي عبر NFC، ودعم لعدة محافظ مستقلة.",
    "lukkey.seoIntent.eyebrow": "دليل محافظ الأجهزة",
    "lukkey.seoIntent.title": "لماذا يبحث المستخدمون عن cold wallet مثل LUKKEY",
    "lukkey.seoIntent.intro": "يجب أن تفعل محفظة الأجهزة أكثر من مجرد أن تبدو آمنة. يجب أن تُبقي المفاتيح الخاصة غير متصلة، وتجعل الاستعادة عملية، وتمنح أصحاب الاحتفاظ طويل الأجل مسار self-custody أوضح.",
    "lukkey.seoIntent.cards.offline.title": "تخزين المفاتيح الخاصة دون اتصال",
    "lukkey.seoIntent.cards.offline.body": "صُممت LUKKEY كمحفظة أجهزة تُبقي المفاتيح الخاصة غير متصلة بدلاً من تركها مكشوفة في المتصفح أو البورصة أو بيئة تطبيق متصل دائماً.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet مقابل hot wallet",
    "lukkey.seoIntent.cards.compare.body": "بالنسبة لحاملي الأصول على المدى الطويل ومستخدمي الكريبتو الجادين، تقلل cold wallet من مساحة الهجوم عن بُعد وتمنح تحكماً مباشراً أكثر من ترك الأصول في البورصات أو المحافظ البرمجية فقط.",
    "lukkey.seoIntent.cards.recovery.title": "الوصول بالبصمة والنسخ الاحتياطي عبر NFC",
    "lukkey.seoIntent.cards.recovery.body": "تجمع LUKKEY بين الأمان المعتمد على العتاد وأدوات الاستعادة العملية، بما في ذلك الوصول بالبصمة للاستخدام اليومي وتدفقات النسخ الاحتياطي عبر NFC من أجل self-custody أكثر أماناً.",
    "lukkey.seoIntent.cards.fit.title": "مصممة للحفظ الذاتي الآمن",
    "lukkey.seoIntent.cards.fit.body": "إذا كنت تبحث عن محفظة أجهزة لـ Bitcoin وEthereum وUSDT وإدارة عدة حسابات، فقد صُممت LUKKEY حول الخصوصية والفصل والتحكم طويل الأجل.",
    "lukkey.highlights.title": "تعرّف على أبرز مزايا Lukkey.",
    "lukkey.physical.title": "الأمان، مدمج في السيليكون.",
    "lukkey.physical.subtitle":
      "بنية أمان عتادية مبنية على عدة عناصر آمنة، ترتكز على جذر ثقة EAL6+ ومدعومة بدارات وهيكل مقاومين للعبث.",
    "lukkey.design.title": "التصميم ليس زينة، بل مصداقية",
    "lukkey.design.description":
      "تصميم صناعي بحرفية بمستوى iF وRed Dot، يبرز الحواف المشطوفة وانعكاسات الزجاج الدقيقة.",
    "lukkey.reliability.title": "مقاومة الماء IP68\nمقاومة الغبار IP6X",
    "lukkey.reliability.description":
      "حماية مقاومة للماء بمعيار IP68 ومقاومة للغبار بمعيار IP6X، مصممة لمنع تسرب الماء والجزيئات الدقيقة في البيئات القاسية.",
    "lukkey.reliability.canvasLine1": "مقاومة الماء IP68",
    "lukkey.reliability.canvasLine2": "مقاومة الغبار IP6X",
    "lukkey.system.title": "الوضع الآمن",
    "lukkey.system.description":
      "طبقة حماية خفية للمواقف الحساسة.\n\nيقوم Safenotes بتمويه واجهة المحفظة لتبدو كصفحة ملاحظات،\nبينما يبقى الحساب النشط فقط مرئيًا.\nكما تُقيد العمليات الحساسة مثل حذف حساب واحد.",
    "lukkey.system.multiAccountTitle": "يدعم 3 عبارات استرداد مستقلة",
    "lukkey.system.multiAccountDescription":
      "أنشئ حتى ثلاث محافظ مستقلة تمامًا، كل واحدة مؤمنة بعبارة الاسترداد الخاصة بها. افصل الأصول أو الاستراتيجيات أو الهويات مع الحفاظ على تحكم كامل في أصولك الرقمية.",
    "lukkey.daily.title": "فتح بالبصمة",
    "lukkey.daily.description":
      "افتح محفظتك فورًا باستخدام بصمة الإصبع.\n\nسريع وسلس ويتم التحقق مباشرة على الجهاز.",
    "lukkey.capability.title": "دعم NFT",
    "lukkey.capability.description":
      "مساحة عرض أصول داكنة مع بطاقات ذات طابع زجاجي وتشبع منخفض لإبراز الملكية والتحكم.",
    "lukkey.backup.title": "بطاقة نسخ احتياطي NFC",
    "lukkey.backup.description":
      "بطاقة نسخ احتياطي NFC مزودة بعنصر أمان EAL6+.\nما عليك سوى لمس الجهاز لنسخ عبارات الاسترداد احتياطيًا أو استيرادها بأمان.",
    "lukkey.trust.title": "أمان مفتوح وقابل للتحقق",
    "lukkey.trust.description":
      "يعتمد LUKKEY على عنصر أمان EAL6+ وبنية مفتوحة المصدر،\nويتيح التحقق المستقل من أمان العتاد والبرمجيات.\n\nيبقى إنشاء المفاتيح وتخزينها وتوقيعها محميًا داخل الجهاز،\nبينما يسمح الكود مفتوح المصدر بمراجعة أمنية شفافة من قبل المجتمع.\n\nأمان يمكنك التحقق منه. وتحكم يبقى لك.",
    "lukkey.video.title": "مصمم للحماية. ومهيأ للاستمرار.",
    "lukkey.video.description":
      "مصنوع بدقة سويسرية ومهووس بالأمان، LUKKEY هو المحفظة الباردة لمن يطلبون تحكمًا كاملًا.",
    "lukkey.values.privacy.title": "الخصوصية",
    "lukkey.values.privacy.description":
      "مفاتيحك لا تغادر الجهاز أبدًا. يضمن التوقيع المعزول هوائيًا بقاء العمليات الحساسة غير متصلة بالكامل.",
    "lukkey.values.inclusive.title": "تصميم شامل",
    "lukkey.values.inclusive.description":
      "تصميم يتمحور حول الإنسان، واضح للمبتدئين وفعال للخبراء.",
    "lukkey.values.secure.title": "آمن",
    "lukkey.values.secure.description":
      "حماية مدعومة بالعتاد مع طبقات متعددة ضد العبث والاستخراج والانتحال.",
    "lukkey.values.environment.title": "الاستدامة",
    "lukkey.values.environment.description":
      "مبني للاستخدام طويل الأمد بمواد متينة وهيكل قابل للصيانة ونفايات أقل من الاستبدال المتكرر.",
    "lukkey.contact.title": "ابق على تواصل",
    "lukkey.contact.announcements": "يمكن العثور على الإعلانات في مدونتنا.",
    "lukkey.contact.pressLabel": "اتصال الصحافة:",
  },
  tl: {
    "lukkey.hero.subtitle": "Mga asset mo, kontrol mo.",
    "lukkey.hero.reserveSubtitle":
      "Magpareserba sa halagang $1. Makakuha ng Early Bird pricing, priority access, at libreng NFC backup card.",
    "lukkey.hero.heroCtaLabel": "Magpareserba sa halagang $1",
    "lukkey.hero.heroCtaNote": "Ganap na refundable. Walang obligasyong bumili.",
    "lukkey.hero.buy": "Magpareserba ng Lukkey sa halagang $1",
    "lukkey.hero.buyWithPrice": "Magpareserba ng Lukkey sa halagang {{price}}",
    "lukkey.hero.swissBadgeLabel": "Swiss na brand",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Offline crypto cold wallet na may fingerprint access",
    "lukkey.seo.description": "Ang LUKKEY ay isang Swiss hardware wallet para sa ligtas na self-custody, na may offline na proteksyon ng private key, EAL6+ secure chip, fingerprint access, NFC backup, at suporta para sa maraming independent wallet.",
    "lukkey.seoIntent.eyebrow": "Gabay sa hardware wallet",
    "lukkey.seoIntent.title": "Bakit naghahanap ang mga user ng cold wallet tulad ng LUKKEY",
    "lukkey.seoIntent.intro": "Ang hardware wallet ay dapat gumawa ng higit pa sa mukhang ligtas. Dapat nitong panatilihing offline ang private key, gawing praktikal ang recovery, at bigyan ang mga long-term holder ng mas malinaw na self-custody workflow.",
    "lukkey.seoIntent.cards.offline.title": "Offline na imbakan ng private key",
    "lukkey.seoIntent.cards.offline.body": "Idinisenyo ang LUKKEY bilang hardware wallet na nagpapanatiling offline ang private key sa halip na iwan itong exposed sa browser, exchange, o app environment na laging konektado.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Para sa mga long-term holder at seryosong crypto user, binabawasan ng cold wallet ang remote attack surface at nagbibigay ng mas direktang kontrol kaysa sa pag-iwan ng assets sa exchange o software wallet lamang.",
    "lukkey.seoIntent.cards.recovery.title": "Fingerprint access at NFC backup",
    "lukkey.seoIntent.cards.recovery.body": "Pinagsasama ng LUKKEY ang hardware-first security at praktikal na recovery tools, kabilang ang fingerprint access para sa pang-araw-araw na paggamit at NFC backup flows para sa mas ligtas na self-custody.",
    "lukkey.seoIntent.cards.fit.title": "Ginawa para sa ligtas na self-custody",
    "lukkey.seoIntent.cards.fit.body": "Kung naghahanap ka ng hardware wallet para sa Bitcoin, Ethereum, USDT at multi-account crypto management, idinisenyo ang LUKKEY para sa privacy, separation, at pangmatagalang kontrol.",
    "lukkey.highlights.title": "Tingnan ang mahahalagang tampok ng Lukkey.",
    "lukkey.physical.title": "Seguridad, nakabaon sa silikon.",
    "lukkey.physical.subtitle":
      "Isang hardware security architecture na binuo sa maraming secure element, nakaangkla sa EAL6+ root of trust at pinatatag ng anti-tamper circuit at structural design.",
    "lukkey.design.title": "Ang disenyo ay hindi palamuti, ito ay kredibilidad",
    "lukkey.design.description":
      "Industrial design na may antas ng pagkakagawa na maihahambing sa iF at Red Dot, na binibigyang-diin ang chamfered edges at banayad na glass reflections.",
    "lukkey.reliability.title": "IP68 Waterproof\nIP6X Dustproof",
    "lukkey.reliability.description":
      "IP68 waterproof at IP6X dustproof na proteksyon, ginawa upang hadlangan ang tubig at pinong particle sa matitinding kapaligiran.",
    "lukkey.reliability.canvasLine1": "IP68 Waterproof",
    "lukkey.reliability.canvasLine2": "IP6X Dustproof",
    "lukkey.system.title": "Safe Mode",
    "lukkey.system.description":
      "Isang maingat na proteksiyon na layer para sa sensitibong mga sitwasyon.\n\nGinagawang parang notes page ng Safenotes ang wallet interface,\nhabang ang aktibong account lang ang nananatiling nakikita.\nPinaghihigpitan din ang mga sensitibong aksyon tulad ng pagtanggal ng iisang account.",
    "lukkey.system.multiAccountTitle":
      "Suporta para sa 3 independiyenteng recovery phrase",
    "lukkey.system.multiAccountDescription":
      "Gumawa ng hanggang tatlong ganap na independiyenteng wallet, bawat isa ay protektado ng sarili nitong recovery phrase. Paghiwalayin ang assets, strategies, o identities habang nananatili ang buong kontrol sa iyong digital assets.",
    "lukkey.daily.title": "Fingerprint Unlock",
    "lukkey.daily.description":
      "I-unlock agad ang iyong wallet gamit ang fingerprint authentication.\n\nMabilis, seamless, at diretso sa device ang verification.",
    "lukkey.capability.title": "Suporta sa NFT",
    "lukkey.capability.description":
      "Isang dark-space asset display bay na may glassy cards at mababang saturation upang bigyang-diin ang pagmamay-ari at kontrol.",
    "lukkey.backup.title": "NFC Backup Card",
    "lukkey.backup.description":
      "Isang NFC backup card na may EAL6+ secure element.\nI-tap lamang ang device upang ligtas na mag-back up o mag-import ng recovery phrases.",
    "lukkey.trust.title": "Bukas at nabeberipikang seguridad",
    "lukkey.trust.description":
      "Nakabatay sa EAL6+ secure element at open-source architecture,\npinapahintulutan ng LUKKEY na independiyenteng ma-verify ang seguridad ng hardware at software.\n\nNanatiling protektado sa loob ng device ang key generation, storage, at signing,\nhabang nagbibigay ang open-source code ng transparent na security review mula sa komunidad.\n\nSeguridad na maaari mong beripikahin. Kontrol na nananatiling iyo.",
    "lukkey.video.title": "Ginawa para magprotekta. Dinisenyo para tumagal.",
    "lukkey.video.description":
      "Swiss-crafted at nakatuon sa seguridad, ang LUKKEY ay ang cold wallet para sa mga taong humihingi ng ganap na kontrol.",
    "lukkey.values.privacy.title": "Privacy",
    "lukkey.values.privacy.description":
      "Hindi kailanman umaalis sa device ang iyong mga key. Tinitiyak ng air-gapped signing na ganap na offline ang mga sensitibong operasyon.",
    "lukkey.values.inclusive.title": "Inclusive Design",
    "lukkey.values.inclusive.description":
      "Human-centered design na malinaw para sa mga baguhan at mahusay para sa mga eksperto.",
    "lukkey.values.secure.title": "Secure",
    "lukkey.values.secure.description":
      "Hardware-backed na proteksiyon na may maraming layer laban sa tampering, extraction, at spoofing.",
    "lukkey.values.environment.title": "Sustainability",
    "lukkey.values.environment.description":
      "Ginawa para sa pangmatagalang paggamit gamit ang matitibay na materyales, madaling ayusing istruktura, at mas kaunting replacement waste.",
    "lukkey.contact.title": "Manatiling konektado",
    "lukkey.contact.announcements": "Makikita ang mga anunsyo sa aming blog.",
    "lukkey.contact.pressLabel": "Press contact:",
  },
  bn: {
    "lukkey.hero.subtitle": "আপনার সম্পদ, আপনার নিয়ন্ত্রণ।",
    "lukkey.hero.reserveSubtitle":
      "মাত্র $1 দিয়ে রিজার্ভ করুন। Early Bird মূল্য, priority access এবং ফ্রি NFC backup card পান।",
    "lukkey.hero.heroCtaLabel": "$1 দিয়ে রিজার্ভ করুন",
    "lukkey.hero.heroCtaNote": "সম্পূর্ণ ফেরতযোগ্য। কেনার কোনো বাধ্যবাধকতা নেই।",
    "lukkey.hero.buy": "$1 দিয়ে Lukkey রিজার্ভ করুন",
    "lukkey.hero.buyWithPrice": "{{price}} দিয়ে Lukkey রিজার্ভ করুন",
    "lukkey.hero.swissBadgeLabel": "সুইস ব্র্যান্ড",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | fingerprint access-সহ offline crypto cold wallet",
    "lukkey.seo.description": "LUKKEY হলো নিরাপদ self-custody-এর জন্য তৈরি একটি Swiss hardware wallet, যেখানে আছে private key-এর offline সুরক্ষা, EAL6+ secure chip, fingerprint access, NFC backup এবং একাধিক স্বাধীন wallet-এর সমর্থন।",
    "lukkey.seoIntent.eyebrow": "Hardware wallet গাইড",
    "lukkey.seoIntent.title": "কেন ব্যবহারকারীরা LUKKEY-এর মতো cold wallet খোঁজে",
    "lukkey.seoIntent.intro": "একটি hardware wallet-এর শুধু নিরাপদ দেখালেই হবে না। এটিকে private key offline রাখতে হবে, recovery-কে ব্যবহারিক করতে হবে, এবং long-term holder-দের জন্য আরও পরিষ্কার self-custody workflow দিতে হবে।",
    "lukkey.seoIntent.cards.offline.title": "private key-এর offline storage",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY এমন একটি hardware wallet হিসেবে তৈরি, যা private key-কে browser, exchange বা সবসময় connected app environment-এ expose না করে offline রাখে।",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "long-term holder এবং serious crypto user-দের জন্য cold wallet remote attack surface কমায় এবং assets শুধু exchange বা software wallet-এ রাখার তুলনায় আরও সরাসরি control দেয়।",
    "lukkey.seoIntent.cards.recovery.title": "fingerprint access এবং NFC backup",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY hardware-first security-এর সঙ্গে practical recovery tools যুক্ত করে, যার মধ্যে আছে দৈনন্দিন ব্যবহারের জন্য fingerprint access এবং আরও নিরাপদ self-custody-এর জন্য NFC backup flow।",
    "lukkey.seoIntent.cards.fit.title": "নিরাপদ self-custody-এর জন্য নির্মিত",
    "lukkey.seoIntent.cards.fit.body": "আপনি যদি Bitcoin, Ethereum, USDT এবং multi-account crypto management-এর জন্য hardware wallet খুঁজে থাকেন, তাহলে LUKKEY privacy, separation এবং long-term control-কে কেন্দ্র করে তৈরি।",
    "lukkey.highlights.title": "Lukkey-এর মূল হাইলাইটগুলো দেখুন।",
    "lukkey.physical.title": "নিরাপত্তা, সিলিকনের ভেতরেই নির্মিত।",
    "lukkey.physical.subtitle":
      "একটি হার্ডওয়্যার নিরাপত্তা স্থাপত্য যা একাধিক সিকিউর এলিমেন্টের উপর নির্মিত, EAL6+ root of trust দ্বারা নোঙর করা, এবং tamper-resistant সার্কিট ও স্ট্রাকচারাল ডিজাইনে শক্তিশালী করা হয়েছে।",
    "lukkey.design.title": "ডিজাইন কেবল অলংকার নয়, এটি বিশ্বাসযোগ্যতা",
    "lukkey.design.description":
      "iF ও Red Dot মানের কারুকার্যসম্পন্ন ইন্ডাস্ট্রিয়াল ডিজাইন, যেখানে chamfered edge এবং সূক্ষ্ম glass reflection তুলে ধরা হয়েছে।",
    "lukkey.reliability.title": "IP68 ওয়াটারপ্রুফ\nIP6X ডাস্টপ্রুফ",
    "lukkey.reliability.description":
      "IP68 ওয়াটারপ্রুফ এবং IP6X ডাস্টপ্রুফ সুরক্ষা, কঠোর পরিবেশেও পানি ও সূক্ষ্ম কণার অনুপ্রবেশ ঠেকানোর জন্য তৈরি।",
    "lukkey.reliability.canvasLine1": "IP68 ওয়াটারপ্রুফ",
    "lukkey.reliability.canvasLine2": "IP6X ডাস্টপ্রুফ",
    "lukkey.system.title": "সেফ মোড",
    "lukkey.system.description":
      "সংবেদনশীল পরিস্থিতির জন্য একটি গোপন সুরক্ষা স্তর।\n\nSafenotes ওয়ালেট ইন্টারফেসকে notes-style পেজে ছদ্মবেশ দেয়,\nএবং শুধুমাত্র সক্রিয় অ্যাকাউন্ট দৃশ্যমান রাখে।\nএকটি অ্যাকাউন্ট মুছে ফেলার মতো সংবেদনশীল অপারেশনও সীমাবদ্ধ থাকে।",
    "lukkey.system.multiAccountTitle":
      "৩টি স্বতন্ত্র recovery phrase-এর সমর্থন",
    "lukkey.system.multiAccountDescription":
      "সর্বোচ্চ তিনটি সম্পূর্ণ স্বাধীন ওয়ালেট তৈরি করুন, প্রতিটি নিজের recovery phrase দ্বারা সুরক্ষিত। আপনার ডিজিটাল সম্পদের উপর পূর্ণ নিয়ন্ত্রণ রেখে asset, strategy বা identity আলাদা করে রাখুন।",
    "lukkey.daily.title": "ফিঙ্গারপ্রিন্ট আনলক",
    "lukkey.daily.description":
      "ফিঙ্গারপ্রিন্ট অথেনটিকেশন দিয়ে সঙ্গে সঙ্গে আপনার ওয়ালেট আনলক করুন।\n\nদ্রুত, মসৃণ এবং সরাসরি ডিভাইসে যাচাইকৃত।",
    "lukkey.capability.title": "NFT সমর্থন",
    "lukkey.capability.description":
      "একটি dark-space asset display bay যেখানে glassy card এবং low saturation ব্যবহার করে মালিকানা ও নিয়ন্ত্রণকে জোর দেওয়া হয়েছে।",
    "lukkey.backup.title": "NFC ব্যাকআপ কার্ড",
    "lukkey.backup.description":
      "EAL6+ secure element-সহ একটি NFC ব্যাকআপ কার্ড।\nনিরাপদে recovery phrase ব্যাকআপ বা ইম্পোর্ট করতে শুধু ডিভাইসে ট্যাপ করুন।",
    "lukkey.trust.title": "উন্মুক্ত ও যাচাইযোগ্য নিরাপত্তা",
    "lukkey.trust.description":
      "EAL6+ secure element এবং open-source architecture-এর উপর নির্মিত,\nLUKKEY হার্ডওয়্যার ও সফটওয়্যার উভয় নিরাপত্তাকেই স্বাধীনভাবে যাচাই করার সুযোগ দেয়।\n\nKey generation, storage এবং signing ডিভাইসের ভেতরেই সুরক্ষিত থাকে,\nআর open-source code কমিউনিটির জন্য স্বচ্ছ নিরাপত্তা পর্যালোচনা সম্ভব করে।\n\nযে নিরাপত্তা আপনি যাচাই করতে পারেন। যে নিয়ন্ত্রণ আপনারই থাকে।",
    "lukkey.video.title": "সুরক্ষার জন্য তৈরি। দীর্ঘস্থায়ীত্বের জন্য নকশা করা।",
    "lukkey.video.description":
      "Swiss-crafted নিখুঁততা ও নিরাপত্তা-কেন্দ্রিক দৃষ্টিভঙ্গিতে তৈরি, LUKKEY হলো সেই cold wallet যারা সম্পূর্ণ নিয়ন্ত্রণ চান তাদের জন্য।",
    "lukkey.values.privacy.title": "গোপনীয়তা",
    "lukkey.values.privacy.description":
      "আপনার key কখনও ডিভাইস ছাড়ে না। Air-gapped signing সংবেদনশীল কাজগুলোকে সম্পূর্ণ অফলাইনে রাখে।",
    "lukkey.values.inclusive.title": "অন্তর্ভুক্তিমূলক নকশা",
    "lukkey.values.inclusive.description":
      "মানবকেন্দ্রিক নকশা, নতুনদের জন্য পরিষ্কার এবং বিশেষজ্ঞদের জন্য কার্যকর।",
    "lukkey.values.secure.title": "নিরাপদ",
    "lukkey.values.secure.description":
      "হার্ডওয়্যার-ভিত্তিক সুরক্ষা, tampering, extraction এবং spoofing-এর বিরুদ্ধে বহুস্তরীয় প্রতিরক্ষা সহ।",
    "lukkey.values.environment.title": "স্থিতিশীলতা",
    "lukkey.values.environment.description":
      "দীর্ঘমেয়াদি ব্যবহারের জন্য টেকসই উপকরণ, রক্ষণাবেক্ষণ-সুবিধাজনক কাঠামো এবং কম replacement waste সহ নির্মিত।",
    "lukkey.contact.title": "যোগাযোগে থাকুন",
    "lukkey.contact.announcements": "ঘোষণাগুলো আমাদের ব্লগে পাওয়া যাবে।",
    "lukkey.contact.pressLabel": "প্রেস যোগাযোগ:",
  },
  mn: {
    "lukkey.hero.subtitle": "Таны хөрөнгө, таны хяналт.",
    "lukkey.hero.reserveSubtitle":
      "1 доллараар урьдчилан захиалаарай. Early Bird үнэ, priority access, үнэгүй NFC нөөц карт аваарай.",
    "lukkey.hero.heroCtaLabel": "1 ам.доллараар захиалах",
    "lukkey.hero.heroCtaNote": "Бүрэн буцаан олголттой. Худалдан авах үүрэг хүлээхгүй.",
    "lukkey.hero.buy": "Lukkey-г 1 доллараар захиалах",
    "lukkey.hero.buyWithPrice": "Lukkey-г {{price}}-аар захиалах",
    "lukkey.hero.swissBadgeLabel": "Швейцарь брэнд",
    "lukkey.seo.title": "LUKKEY Hardware Wallet | Хурууны хээтэй хандалттай offline crypto cold wallet",
    "lukkey.seo.description": "LUKKEY нь аюулгүй self-custody-д зориулсан Швейцарийн hardware wallet бөгөөд private key-ийн offline хамгаалалт, EAL6+ secure chip, хурууны хээтэй хандалт, NFC backup, олон бие даасан wallet-ийн дэмжлэгтэй.",
    "lukkey.seoIntent.eyebrow": "Hardware wallet гарын авлага",
    "lukkey.seoIntent.title": "Яагаад хэрэглэгчид LUKKEY шиг cold wallet хайдаг вэ",
    "lukkey.seoIntent.intro": "Hardware wallet нь зүгээр л аюулгүй харагдахаас илүү зүйл хийх ёстой. Энэ нь private key-ийг offline байлгаж, recovery-г илүү бодитой болгож, урт хугацааны эзэмшигчдэд илүү ойлгомжтой self-custody workflow өгөх ёстой.",
    "lukkey.seoIntent.cards.offline.title": "private key-ийн offline хадгалалт",
    "lukkey.seoIntent.cards.offline.body": "LUKKEY нь private key-ийг browser, exchange эсвэл үргэлж холбогдсон app environment-д ил гаргахын оронд offline байлгахаар бүтээгдсэн hardware wallet юм.",
    "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
    "lukkey.seoIntent.cards.compare.body": "Урт хугацааны эзэмшигчид болон ноцтой crypto хэрэглэгчдийн хувьд cold wallet нь remote attack surface-ийг бууруулж, assets-ийг зөвхөн exchange эсвэл software wallet-д хадгалахаас илүү шууд control өгдөг.",
    "lukkey.seoIntent.cards.recovery.title": "Хурууны хээтэй хандалт ба NFC backup",
    "lukkey.seoIntent.cards.recovery.body": "LUKKEY нь hardware-first security-г practical recovery tools-той хослуулж, өдөр тутмын хэрэглээнд зориулсан хурууны хээтэй хандалт болон илүү аюулгүй self-custody-д зориулсан NFC backup flow-г санал болгодог.",
    "lukkey.seoIntent.cards.fit.title": "Аюулгүй self-custody-д зориулан бүтээгдсэн",
    "lukkey.seoIntent.cards.fit.body": "Хэрэв та Bitcoin, Ethereum, USDT болон multi-account crypto management-д зориулсан hardware wallet хайж байгаа бол LUKKEY нь privacy, separation, урт хугацааны control дээр төвлөрөн бүтээгдсэн.",
    "lukkey.highlights.title": "Lukkey-ийн гол онцлогуудыг үзээрэй.",
    "lukkey.physical.title": "Аюулгүй байдал, цахиурт шингэсэн.",
    "lukkey.physical.subtitle":
      "Олон хамгаалалттай элемент дээр суурилсан, EAL6+ итгэлийн үндсээр зангилагдсан, эвдрэлээс хамгаалах схем ба бүтэцтэй тоног төхөөрөмжийн аюулгүй байдлын архитектур.",
    "lukkey.design.title": "Дизайн бол чимэглэл биш, харин итгэлцэл",
    "lukkey.design.description":
      "iF болон Red Dot түвшний ур чадвартай аж үйлдвэрийн дизайн; налуу ирмэг ба шилэн гадаргын зөөлөн ойлтыг онцолдог.",
    "lukkey.reliability.title": "IP68 усны хамгаалалт\nIP6X тоосны хамгаалалт",
    "lukkey.reliability.description":
      "IP68 усны хамгаалалт болон IP6X тоосны хамгаалалт нь хүнд нөхцөлд ус, нарийн ширхэгт тоосонцрын нэвтрэлтийг хаахаар бүтээгдсэн.",
    "lukkey.reliability.canvasLine1": "IP68 усны хамгаалалт",
    "lukkey.reliability.canvasLine2": "IP6X тоосны хамгаалалт",
    "lukkey.system.title": "Аюулгүй горим",
    "lukkey.system.description":
      "Мэдрэмтгий нөхцөлд зориулсан үл анзаарагдах хамгаалалтын давхарга.\n\nSafenotes нь түрийвчний интерфэйсийг тэмдэглэлийн хуудас мэт харагдуулж,\nзөвхөн идэвхтэй бүртгэлийг л харуулна.\nНэг бүртгэл устгах зэрэг мэдрэмтгий үйлдлүүд мөн хязгаарлагдана.",
    "lukkey.system.multiAccountTitle":
      "3 тусдаа сэргээх үг дэмжинэ",
    "lukkey.system.multiAccountDescription":
      "Тус бүр өөрийн сэргээх үгээр хамгаалагдсан, бүрэн бие даасан 3 хүртэлх түрийвч үүсгээрэй. Дижитал хөрөнгөө бүрэн хянахын зэрэгцээ хөрөнгө, стратеги эсвэл таних тэмдэглэгээгээ тусгаарлаж болно.",
    "lukkey.daily.title": "Хурууны хээ уншиж нээх",
    "lukkey.daily.description":
      "Хурууны хээний баталгаажуулалтаар түрийвчээ шууд нээгээрэй.\n\nХурдан, саадгүй, баталгаажуулалт нь шууд төхөөрөмж дээр хийгдэнэ.",
    "lukkey.capability.title": "NFT дэмжлэг",
    "lukkey.capability.description":
      "Эзэмшил ба хяналтыг тодотгох зорилготой, шилэн мэдрэмжтэй карт болон бага ханасан өнгө бүхий бараан орон зайн хөрөнгийн дэлгэц.",
    "lukkey.backup.title": "NFC нөөц карт",
    "lukkey.backup.description":
      "EAL6+ хамгаалалттай элементтэй NFC нөөц карт.\nСэргээх үгсээ аюулгүйгээр нөөцлөх эсвэл импортлохын тулд төхөөрөмжид зөөлөн хүргэхэд л хангалттай.",
    "lukkey.trust.title": "Нээлттэй, баталгаажуулах боломжтой аюулгүй байдал",
    "lukkey.trust.description":
      "EAL6+ хамгаалалттай элемент болон нээлттэй эхийн архитектур дээр суурилсан,\nLUKKEY нь тоног төхөөрөмж болон программын аюулгүй байдлыг бие даан шалгах боломж олгодог.\n\nТүлхүүр үүсгэх, хадгалах, гарын үсэг зурах үйлдэл төхөөрөмж дотор хамгаалагдсан хэвээр байх бөгөөд,\nнээлттэй эхийн код нь олон нийтэд ил тод аюулгүй байдлын шалгалт хийх боломж олгоно.\n\nТа өөрөө шалгаж болох аюулгүй байдал. Таных хэвээр үлдэх хяналт.",
    "lukkey.video.title": "Хамгаалахын тулд бүтээгдсэн. Удаан ашиглахын тулд зохион бүтээгдсэн.",
    "lukkey.video.description":
      "Швейцарь урлал болон аюулгүй байдалд төвлөрсөн сэтгэлгээгээр бүтээгдсэн LUKKEY нь бүрэн хяналтыг шаарддаг хүмүүст зориулсан хүйтэн түрийвч юм.",
    "lukkey.values.privacy.title": "Нууцлал",
    "lukkey.values.privacy.description":
      "Таны түлхүүрүүд төхөөрөмжөөс хэзээ ч гарахгүй. Air-gapped гарын үсэг нь мэдрэмтгий үйлдлүүдийг бүрэн офлайн байлгана.",
    "lukkey.values.inclusive.title": "Хамруулсан дизайн",
    "lukkey.values.inclusive.description":
      "Хүнд төвлөрсөн дизайн нь анхлан хэрэглэгчдэд ойлгомжтой, туршлагатай хэрэглэгчдэд үр ашигтай.",
    "lukkey.values.secure.title": "Аюулгүй",
    "lukkey.values.secure.description":
      "Эвдрэл, олборлолт, хуурамч үйлдлээс хамгаалах олон давхар хамгаалалттай тоног төхөөрөмжийн хамгаалалт.",
    "lukkey.values.environment.title": "Тогтвортой байдал",
    "lukkey.values.environment.description":
      "Удаан хугацааны хэрэглээнд зориулсан бат бөх материал, засварлах боломжтой бүтэц, бага солилцооны хаягдалтайгаар бүтээгдсэн.",
    "lukkey.contact.title": "Холбоотой байгаарай",
    "lukkey.contact.announcements": "Заруудыг манай блогоос үзэх боломжтой.",
    "lukkey.contact.pressLabel": "Хэвлэлийн холбоо:",
  },
};

const lukkeyLocalizedExtendedTranslations = {
  zh: {
    "lukkey.hero.title": "LUKKEY",
    "lukkey.hero.imageAlt": "Lukkey 冷钱包主视觉产品图",
    "lukkey.physical.annotation.title": "硬件级信任根。",
    "lukkey.physical.annotation.description":
      "多个安全元件以 EAL6+ 为锚点，并通过防篡改电路与结构设计进一步加固。",
    "lukkey.physical.cardTamper.title": "PCI 级防篡改（灌封 + 自毁）",
    "lukkey.physical.cardTamper.description":
      "以爆炸结构展示核心芯片周围的半透明灌封层，层次清晰，但无法触达。",
    "lukkey.physical.cardChip.title": "EAL6+ 安全芯片",
    "lukkey.physical.cardChip.description":
      "芯片悬浮于暗色空间中，数据光束始终被限制在安全边界内。",
    "lukkey.physical.explode.coreChip": "核心芯片",
    "lukkey.physical.explode.securityBoundary": "安全边界",
    "lukkey.physical.explode.pottingLayer": "灌封层",
    "lukkey.physical.explode.outerShell": "外壳",
    "lukkey.design.featureTitle": "彩色触控屏 · 卡片尺寸机身",
    "lukkey.design.featureDescription":
      "与真实银行卡 1:1 对比，突出仅 9.6mm 的便携厚度。",
    "lukkey.design.thickness": "厚度 9.6mm",
    "lukkey.design.closing":
      "即使经过微距转场和流动高光，最终依然回归为克制而精致的完整形态。",
    "lukkey.design.controls.closePanel": "关闭功能面板",
    "lukkey.design.feature.colors": "颜色",
    "lukkey.design.feature.sizes": "尺寸",
    "lukkey.design.feature.display": "屏幕",
    "lukkey.design.feature.connectivity": "连接",
    "lukkey.design.feature.durability": "续航",
    "lukkey.design.color.champagne": "香槟金",
    "lukkey.design.color.black": "黑色",
    "lukkey.design.color.silver": "银色",
    "lukkey.design.panel.colors.title": "颜色。",
    "lukkey.design.panel.colors.body": "提供三种鲜明而有辨识度的外观配色。",
    "lukkey.design.panel.colors.selected": "当前展示的是 {{color}} 的 LUKKEY。",
    "lukkey.design.panel.sizes.body":
      "尺寸：93.2 mm（长）x 56.7 mm（宽）x 9.6 mm（高）。重量：85 克。信用卡级占地面积，厚度紧凑，适合日常随身携带。",
    "lukkey.design.panel.display.body":
      "屏幕：4.3 英寸触控屏，分辨率 480 x 800，便于清晰确认与签名。",
    "lukkey.design.panel.connectivity.body":
      "连接：支持蓝牙，实现安全的无线连接与交易流程。",
    "lukkey.design.panel.durability.body": "最长可连续使用 3 小时。",
    "lukkey.reliability.bullet1": "慢动作水流完整包裹设备",
    "lukkey.reliability.bullet2": "高速水滴冲击，依然零渗入",
    "lukkey.reliability.bullet3": "防尘、防水、抗跌落",
    "lukkey.reliability.imageAlt": "Lukkey IP68 防水展示",
    "lukkey.system.account.accountA": "账户 A",
    "lukkey.system.account.hiddenWallet": "隐藏钱包",
    "lukkey.system.account.decoyVault": "诱饵钱包",
    "lukkey.system.account.locked": "已锁定",
    "lukkey.system.layers.primary": "主层",
    "lukkey.system.layers.vault": "金库",
    "lukkey.system.layers.shadow": "影子层",
    "lukkey.system.modalImageAlt": "LUKKEY 钱包产品图",
    "lukkey.system.openDetailsAria": "打开 {{title}} 的详情",
    "lukkey.system.safeModeAccess.titleStrong": "安全模式\n访问",
    "lukkey.system.safeModeAccess.titleSoft":
      "输入专用密码后会打开伪装页面，并隐藏其他账户。",
    "lukkey.system.safeModeAccess.modalTitle": "安全模式访问",
    "lukkey.system.safeModeAccess.modalDescription":
      "专用的安全模式密码会打开伪装成备忘录的界面，因此只显示目标账户，其余钱包内容保持隐藏。",
    "lukkey.system.safeModeAccess.bullet1":
      "解锁后进入诱饵界面，而不是完整的钱包首页",
    "lukkey.system.safeModeAccess.bullet2":
      "在敏感场景下让非当前账户始终不出现在视图中",
    "lukkey.system.safeModeAccess.bullet3":
      "在日常检查中降低暴露隐藏资产的风险",
    "lukkey.system.safeModeAccess.imageAlt": "安全模式访问示意图",
    "lukkey.system.hiddenAccounts.titleStrong": "隐藏\n账户",
    "lukkey.system.hiddenAccounts.titleSoft":
      "诱饵访问会让敏感钱包保持隐藏，直到输入正确密码才会显示。",
    "lukkey.system.hiddenAccounts.modalTitle": "隐藏账户",
    "lukkey.system.hiddenAccounts.modalDescription":
      "敏感钱包会被诱饵访问机制隐藏起来。只有输入正确密码，真实账户集合才会显示，从而降低被意外发现的概率。",
    "lukkey.system.hiddenAccounts.bullet1":
      "将可见的诱饵账户与高价值隐藏钱包分离",
    "lukkey.system.hiddenAccounts.bullet2":
      "在日常解锁流程中阻止隐藏钱包出现",
    "lukkey.system.hiddenAccounts.bullet3":
      "为出行、公共场合和胁迫场景增加实用隐私层",
    "lukkey.capability.nftItem": "NFT #{{index}}",
    "lukkey.backup.imageAlt": "NFC 助记词备份演示",
    "lukkey.trust.imageAlt": "开源验证预览图",
    "lukkey.modal.contentLabel": "邮箱确认",
    "lukkey.modal.title": "确认你的邮箱",
    "lukkey.modal.description1":
      "请打开发送给你的确认邮件并点击验证链接，也请记得检查垃圾邮件文件夹。",
    "lukkey.modal.description2": "你可以随时取消订阅。",
    "lukkey.modal.close": "关闭",
    "lukkey.modal.closeDialog": "关闭对话框",
    "lukkey.faq.faq1.question": "LUKKEY 与其他硬件钱包有什么不同？",
    "lukkey.faq.faq1.paragraph1":
      "LUKKEY 的设计目标，是把强安全性与日常易用性结合在一起。",
    "lukkey.faq.faq1.paragraph2":
      "LUKKEY 希望让每个人的自托管都更安全，也更容易上手。",
    "lukkey.faq.faq1.bullet1": "EAL6+ 安全元件芯片，提供更高级的密钥保护",
    "lukkey.faq.faq1.bullet2": "指纹认证，兼顾快速与安全访问",
    "lukkey.faq.faq1.bullet3": "一台设备内支持三套独立钱包，方便资产隔离与隐私管理",
    "lukkey.faq.faq1.bullet4": "冷签名架构，让私钥始终保持离线",
    "lukkey.faq.faq2.question": "LUKKEY 是开源的吗？",
    "lukkey.faq.faq2.paragraph1":
      "是的。LUKKEY 是开源的，社区可以审查代码并进行独立的安全审计。",
    "lukkey.faq.faq2.paragraph2":
      "我们认为，硬件钱包应当是透明且可验证的，而开源正是建立这种信任的核心部分。",
    "lukkey.faq.faq3.question": "EAL6+ 安全元件的作用是什么？",
    "lukkey.faq.faq3.paragraph1":
      "EAL6+ 安全元件是一种专门用于保护敏感加密数据的芯片。",
    "lukkey.faq.faq3.paragraph2":
      "它会在防篡改环境中安全存储私钥，并在芯片内部完成加密运算，以保护你的资产免受物理和数字攻击。",
    "lukkey.faq.faq3.paragraph3":
      "这种级别的安全认证常见于银行卡、护照以及高安全设备中。",
    "lukkey.faq.faq4.question": "我可以在一台设备上创建三套独立钱包吗？",
    "lukkey.faq.faq4.paragraph1": "可以。",
    "lukkey.faq.faq4.paragraph2":
      "LUKKEY 支持在单一设备上创建三套完全独立的钱包，每套都拥有各自的私钥和助记词。",
    "lukkey.faq.faq4.paragraph3": "每套钱包都会独立且安全地运行。",
    "lukkey.faq.faq4.bullet1": "区分长期持仓与日常资金",
    "lukkey.faq.faq4.bullet2": "管理不同投资组合",
    "lukkey.faq.faq4.bullet3": "创建隐藏钱包或诱饵钱包以增强隐私",
    "lukkey.faq.faq5.question": "如果我丢失了设备，会发生什么？",
    "lukkey.faq.faq5.paragraph1":
      "你的加密资产并不存储在设备上，而是存在区块链上。",
    "lukkey.faq.faq5.paragraph2":
      "在设置 LUKKEY 时，你会生成一组用于恢复钱包的助记词。",
    "lukkey.faq.faq5.paragraph3":
      "LUKKEY 还支持 NFC 备份卡，为安全保存恢复信息提供更便捷的方式。",
    "lukkey.faq.faq5.paragraph4":
      "如果设备丢失或损坏，你可以使用助记词或 NFC 备份卡恢复钱包。",
    "lukkey.faq.faq5.paragraph5":
      "只要你的备份安全，资金就是安全的。",
    "lukkey.faq.faq6.question": "1 美元预定包含哪些权益？",
    "lukkey.faq.faq6.paragraph1":
      "1 美元预定可为你锁定早鸟优惠资格，并在众筹上线前进入优先名单。",
    "lukkey.faq.faq6.paragraph2":
      "在正式上线前，你会先收到通知，并获得完整的预订礼遇。",
    "lukkey.faq.faq6.bullet1": "早鸟价立减 20 美元",
    "lukkey.faq.faq6.bullet2": "第一时间收到上线邮件，并抢先进入众筹页面",
    "lukkey.faq.faq6.bullet3": "优先发货",
    "lukkey.faq.faq6.bullet4": "VIP 社群资格",
    "lukkey.faq.faq6.bullet5": "限量版 NFC 备份卡和专属 IP 礼品",
    "lukkey.faq.faq7.question": "LUKKEY 什么时候会在 Kickstarter 上线？",
    "lukkey.faq.faq7.paragraph1":
      "LUKKEY 计划于 2026 年在 Kickstarter 上线。",
    "lukkey.faq.faq7.paragraph2":
      "所有预定用户都会在公开上线前收到抢先访问资格和通知。",
    "lukkey.faq.faq8.question": "LUKKEY 将支持哪些资产？",
    "lukkey.faq.faq8.paragraph1":
      "LUKKEY 支持 30+ 条区块链网络，以及数千种加密货币和 NFT 资产。",
    "lukkey.faq.faq8.paragraph2":
      "用户可以在一台设备上安全管理加密货币和 NFT。",
    "lukkey.faq.faq8.paragraph3":
      "更多网络和资产会继续通过固件与应用更新加入支持。",
    "lukkey.faq.faq8.bullet1": "比特币（BTC）",
    "lukkey.faq.faq8.bullet2": "以太坊（ETH）",
    "lukkey.faq.faq8.bullet3": "USDT",
    "lukkey.faq.faq8.bullet4": "BNB Chain",
    "lukkey.faq.faq8.bullet5": "TRON",
    "lukkey.faq.faq8.bullet6": "Polygon",
    "lukkey.faq.faq8.bullet7": "以及更多",
  },
  "zh-TW": {
    "lukkey.hero.title": "LUKKEY",
    "lukkey.seo.title": "LUKKEY 硬體錢包 | 支援指紋存取的離線加密冷錢包",
    "lukkey.seo.description":
      "LUKKEY 是面向安全自我託管的瑞士硬體錢包，提供離線私鑰保護、EAL6+ 安全晶片、指紋存取、NFC 備份，以及多組獨立錢包支援。",
    "lukkey.seoIntent.eyebrow": "硬體錢包選購指南",
    "lukkey.seoIntent.title": "為什麼使用者會搜尋像 LUKKEY 這樣的冷錢包",
    "lukkey.seoIntent.intro":
      "一款硬體錢包不該只是看起來安全，還應真正讓私鑰保持離線、讓恢復流程更可控，並為長期持幣者提供更清晰的自我託管路徑。",
    "lukkey.seoIntent.cards.offline.title": "離線私鑰儲存",
    "lukkey.seoIntent.cards.offline.body":
      "LUKKEY 作為硬體冷錢包，核心目標是讓私鑰始終停留在離線環境中，而不是暴露在瀏覽器、交易所或持續連網的軟體錢包裡。",
    "lukkey.seoIntent.cards.compare.title": "冷錢包與熱錢包的差異",
    "lukkey.seoIntent.cards.compare.body":
      "對長期持有者和重視安全的加密使用者來說，冷錢包能降低遠端攻擊面，相比僅把資產放在交易所或軟體錢包裡，擁有更直接的控制權。",
    "lukkey.seoIntent.cards.recovery.title": "指紋存取與 NFC 備份",
    "lukkey.seoIntent.cards.recovery.body":
      "LUKKEY 將硬體級安全與日常可用性結合，用指紋存取提升效率，並以 NFC 備份流程讓自我託管的恢復更安全、更順手。",
    "lukkey.seoIntent.cards.fit.title": "為安全自我託管而生",
    "lukkey.seoIntent.cards.fit.body":
      "如果你正在尋找適合 Bitcoin、Ethereum、USDT 以及多帳戶管理的硬體錢包，LUKKEY 的設計重點就是隱私、隔離與長期控制權。",
    "lukkey.hero.imageAlt": "Lukkey 冷錢包主視覺產品圖",
    "lukkey.physical.annotation.title": "硬體級信任根。",
    "lukkey.physical.annotation.description":
      "多個安全元件以 EAL6+ 為核心，並透過防篡改電路與結構設計進一步強化。",
    "lukkey.physical.cardTamper.title": "PCI 級防篡改（灌封 + 自毀）",
    "lukkey.physical.cardTamper.description":
      "以爆炸結構視覺化呈現核心晶片周圍的半透明灌封層，層次清楚，但無法觸及。",
    "lukkey.physical.cardChip.title": "EAL6+ 安全晶片",
    "lukkey.physical.cardChip.description":
      "晶片懸浮於暗色空間中，資料光束始終被限制在安全邊界內。",
    "lukkey.physical.explode.coreChip": "核心晶片",
    "lukkey.physical.explode.securityBoundary": "安全邊界",
    "lukkey.physical.explode.pottingLayer": "灌封層",
    "lukkey.physical.explode.outerShell": "外殼",
    "lukkey.design.featureTitle": "彩色觸控螢幕 · 卡片尺寸機身",
    "lukkey.design.featureDescription":
      "與真實銀行卡 1:1 對比，突顯僅 9.6mm 的便攜厚度。",
    "lukkey.design.thickness": "厚度 9.6mm",
    "lukkey.design.closing":
      "即使經過微距轉場與流動高光，最終依然回到克制而精緻的完整形態。",
    "lukkey.design.controls.closePanel": "關閉功能面板",
    "lukkey.design.feature.colors": "顏色",
    "lukkey.design.feature.sizes": "尺寸",
    "lukkey.design.feature.display": "螢幕",
    "lukkey.design.feature.connectivity": "連線",
    "lukkey.design.feature.durability": "續航",
    "lukkey.design.color.champagne": "香檳金",
    "lukkey.design.color.black": "黑色",
    "lukkey.design.color.silver": "銀色",
    "lukkey.design.panel.colors.title": "顏色。",
    "lukkey.design.panel.colors.body": "提供三種鮮明且有辨識度的外觀配色。",
    "lukkey.design.panel.colors.selected": "目前顯示的是 {{color}} 的 LUKKEY。",
    "lukkey.design.panel.sizes.body":
      "尺寸：93.2 mm（長）x 56.7 mm（寬）x 9.6 mm（高）。重量：85 克。信用卡級佔地面積，厚度緊湊，適合日常隨身攜帶。",
    "lukkey.design.panel.display.body":
      "螢幕：4.3 吋觸控螢幕，解析度 480 x 800，便於清楚確認與簽署。",
    "lukkey.design.panel.connectivity.body":
      "連線：支援藍牙，實現安全的無線連接與交易流程。",
    "lukkey.design.panel.durability.body": "最長可連續使用 3 小時。",
    "lukkey.reliability.bullet1": "慢動作水流完整包覆裝置",
    "lukkey.reliability.bullet2": "高速水滴衝擊，依然零滲入",
    "lukkey.reliability.bullet3": "防塵、防水、抗摔落",
    "lukkey.reliability.imageAlt": "Lukkey IP68 防水展示",
    "lukkey.system.account.accountA": "帳戶 A",
    "lukkey.system.account.hiddenWallet": "隱藏錢包",
    "lukkey.system.account.decoyVault": "誘餌錢包",
    "lukkey.system.account.locked": "已鎖定",
    "lukkey.system.layers.primary": "主層",
    "lukkey.system.layers.vault": "金庫",
    "lukkey.system.layers.shadow": "影子層",
    "lukkey.system.modalImageAlt": "LUKKEY 錢包產品圖",
    "lukkey.system.openDetailsAria": "開啟 {{title}} 的詳細資訊",
    "lukkey.system.safeModeAccess.titleStrong": "安全模式\n存取",
    "lukkey.system.safeModeAccess.titleSoft":
      "輸入專用密碼後會開啟偽裝頁面，並隱藏其他帳戶。",
    "lukkey.system.safeModeAccess.modalTitle": "安全模式存取",
    "lukkey.system.safeModeAccess.modalDescription":
      "專用的安全模式密碼會開啟偽裝成備忘錄的介面，因此只顯示目標帳戶，其餘錢包內容保持隱藏。",
    "lukkey.system.safeModeAccess.bullet1":
      "解鎖後進入誘餌介面，而不是完整的錢包首頁",
    "lukkey.system.safeModeAccess.bullet2":
      "在敏感情境下讓非目前帳戶始終不出現在畫面中",
    "lukkey.system.safeModeAccess.bullet3":
      "在日常檢查時降低暴露隱藏資產的風險",
    "lukkey.system.safeModeAccess.imageAlt": "安全模式存取示意圖",
    "lukkey.system.hiddenAccounts.titleStrong": "隱藏\n帳戶",
    "lukkey.system.hiddenAccounts.titleSoft":
      "誘餌存取會讓敏感錢包保持隱藏，直到輸入正確密碼才會顯示。",
    "lukkey.system.hiddenAccounts.modalTitle": "隱藏帳戶",
    "lukkey.system.hiddenAccounts.modalDescription":
      "敏感錢包會被誘餌存取機制隱藏起來。只有輸入正確密碼，真實帳戶集合才會顯示，從而降低被意外發現的機率。",
    "lukkey.system.hiddenAccounts.bullet1":
      "將可見的誘餌帳戶與高價值隱藏錢包分離",
    "lukkey.system.hiddenAccounts.bullet2":
      "在日常解鎖流程中阻止隱藏錢包出現",
    "lukkey.system.hiddenAccounts.bullet3":
      "為旅行、公共場所以及脅迫情境增加實用隱私層",
    "lukkey.capability.nftItem": "NFT #{{index}}",
    "lukkey.backup.imageAlt": "NFC 助記詞備份示範",
    "lukkey.trust.imageAlt": "開源驗證預覽圖",
    "lukkey.modal.contentLabel": "電子郵件確認",
    "lukkey.modal.title": "確認你的電子郵件",
    "lukkey.modal.description1":
      "請打開寄給你的確認郵件並點擊驗證連結，也請記得檢查垃圾郵件資料夾。",
    "lukkey.modal.description2": "你可以隨時取消訂閱。",
    "lukkey.modal.close": "關閉",
    "lukkey.modal.closeDialog": "關閉對話框",
    "lukkey.faq.faq1.question": "LUKKEY 與其他硬體錢包有什麼不同？",
    "lukkey.faq.faq1.paragraph1":
      "LUKKEY 的設計目標，是把高安全性與日常易用性結合在一起。",
    "lukkey.faq.faq1.paragraph2":
      "LUKKEY 希望讓每個人的自我託管都更安全，也更容易上手。",
    "lukkey.faq.faq1.bullet1": "EAL6+ 安全元件晶片，提供更高等級的金鑰保護",
    "lukkey.faq.faq1.bullet2": "指紋驗證，兼顧快速與安全存取",
    "lukkey.faq.faq1.bullet3": "一台裝置支援三組獨立錢包，方便資產隔離與隱私管理",
    "lukkey.faq.faq1.bullet4": "冷簽章架構，讓私鑰始終保持離線",
    "lukkey.faq.faq2.question": "LUKKEY 是開源的嗎？",
    "lukkey.faq.faq2.paragraph1":
      "是的。LUKKEY 是開源的，社群可以審查程式碼並進行獨立的安全稽核。",
    "lukkey.faq.faq2.paragraph2":
      "我們認為，硬體錢包應當是透明且可驗證的，而開源正是建立這種信任的核心部分。",
    "lukkey.faq.faq3.question": "EAL6+ 安全元件的作用是什麼？",
    "lukkey.faq.faq3.paragraph1":
      "EAL6+ 安全元件是一種專門用於保護敏感加密資料的晶片。",
    "lukkey.faq.faq3.paragraph2":
      "它會在防篡改環境中安全儲存私鑰，並在晶片內部完成加密運算，以保護你的資產免受實體與數位攻擊。",
    "lukkey.faq.faq3.paragraph3":
      "這種等級的安全認證常見於銀行卡、護照與高安全裝置。",
    "lukkey.faq.faq4.question": "我可以在一台裝置上建立三組獨立錢包嗎？",
    "lukkey.faq.faq4.paragraph1": "可以。",
    "lukkey.faq.faq4.paragraph2":
      "LUKKEY 支援在單一裝置上建立三組完全獨立的錢包，每組都擁有各自的私鑰與助記詞。",
    "lukkey.faq.faq4.paragraph3": "每組錢包都會獨立且安全地運作。",
    "lukkey.faq.faq4.bullet1": "區分長期持倉與日常資金",
    "lukkey.faq.faq4.bullet2": "管理不同投資組合",
    "lukkey.faq.faq4.bullet3": "建立隱藏錢包或誘餌錢包以提升隱私",
    "lukkey.faq.faq5.question": "如果我遺失了裝置，會發生什麼事？",
    "lukkey.faq.faq5.paragraph1":
      "你的加密資產並不儲存在裝置上，而是存在區塊鏈上。",
    "lukkey.faq.faq5.paragraph2":
      "在設定 LUKKEY 時，你會產生一組用於恢復錢包的助記詞。",
    "lukkey.faq.faq5.paragraph3":
      "LUKKEY 也支援 NFC 備份卡，提供更方便的方式來安全保存恢復資訊。",
    "lukkey.faq.faq5.paragraph4":
      "如果裝置遺失或損壞，你可以使用助記詞或 NFC 備份卡恢復錢包。",
    "lukkey.faq.faq5.paragraph5":
      "只要你的備份是安全的，資金就是安全的。",
    "lukkey.faq.faq6.question": "1 美元預訂包含哪些權益？",
    "lukkey.faq.faq6.paragraph1":
      "1 美元預訂可為你鎖定早鳥優惠資格，並在眾籌上線前進入優先名單。",
    "lukkey.faq.faq6.paragraph2":
      "在正式上線前，你會先收到通知，並獲得完整的預訂禮遇。",
    "lukkey.faq.faq6.bullet1": "早鳥價現折 20 美元",
    "lukkey.faq.faq6.bullet2": "第一時間收到上線通知郵件，並搶先進入眾籌頁面",
    "lukkey.faq.faq6.bullet3": "優先出貨",
    "lukkey.faq.faq6.bullet4": "VIP 社群資格",
    "lukkey.faq.faq6.bullet5": "限量版 NFC 備份卡和專屬 IP 禮品",
    "lukkey.faq.faq7.question": "LUKKEY 何時會在 Kickstarter 上線？",
    "lukkey.faq.faq7.paragraph1":
      "LUKKEY 計劃於 2026 年在 Kickstarter 上線。",
    "lukkey.faq.faq7.paragraph2":
      "所有預訂用戶都會在公開上線前收到搶先存取資格與通知。",
    "lukkey.faq.faq8.question": "LUKKEY 將支援哪些資產？",
    "lukkey.faq.faq8.paragraph1":
      "LUKKEY 支援 30+ 條區塊鏈網路，以及數千種加密貨幣與 NFT 資產。",
    "lukkey.faq.faq8.paragraph2":
      "使用者可以在一台裝置上安全管理加密貨幣與 NFT。",
    "lukkey.faq.faq8.paragraph3":
      "更多網路與資產將持續透過韌體與 App 更新加入支援。",
    "lukkey.faq.faq8.bullet1": "比特幣（BTC）",
    "lukkey.faq.faq8.bullet2": "以太坊（ETH）",
    "lukkey.faq.faq8.bullet3": "USDT",
    "lukkey.faq.faq8.bullet4": "BNB Chain",
    "lukkey.faq.faq8.bullet5": "TRON",
    "lukkey.faq.faq8.bullet6": "Polygon",
    "lukkey.faq.faq8.bullet7": "以及更多",
  },
};

export const lukkeyLocalizedTranslations = Object.fromEntries(
  Object.entries(lukkeyLocalizedCoreTranslations).map(([lang, translation]) => [
    lang,
    {
      ...translation,
      ...(lukkeyLocalizedExtendedTranslations[lang] || {}),
    },
  ]),
);
